// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./LineIcons.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/trailer_wearhouse.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/jvectormap/2.0.4/jquery-jvectormap.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Table Of Content
=================================
* Color system
* Body
* Typography
* Todos
* Calendar
* Notes
* Search
* Notifications
* Breadcrumbs
* Alerts
* Badges
* Buttons
* Cards
* Dropdowns
* Forms
* List Groups
* Modals
* Progress bars
* Tables
* Tabs
* Signup
* Login
* Forgot Password
*/
/* Default color & font Variables */
/* End default color & font Variables */
/* Default style */
body {
  background-color: #f3f6f9;
  color: #47404f;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
}

a {
  transition: 0.4s;
  -webkit-transition: 0.4s;
}
a:hover {
  text-decoration: none;
  color: #2962ff;
}

p {
  color: #797979;
  line-height: 24px;
}

img {
  max-width: 100%;
}

.input-group-text {
  padding: 3px 13px;
}

iframe {
  border: 0;
}

.form-select {
  font-size: 13px;
}

/* Scrollbar style */
::-webkit-scrollbar {
  width: 4px;
  height: 6px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px #ebebee;
  border-radius: 30px;
}

::-webkit-scrollbar-thumb {
  border-radius: 30px;
  background: #2962ff;
  box-shadow: inset 0 0 6px #ebebee;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #2962ff;
}

/* End Scrollbar style */
button:focus {
  outline: 0;
}

.btn {
  font-size: 13px;
  padding: 10px 15px;
  line-height: 1;
  border-radius: 4px;
}

.badge {
  padding-right: 10px;
  padding-left: 10px;
  font-size: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.btn-outline-light {
  color: #848484;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 10px 25px;
  font-size: 16px;
  line-height: 1.5;
}

.btn-md {
  padding: 10px 20px;
  font-size: 15px;
}

.btn-xs {
  padding: 8px 16px;
  font-size: 13px;
}

.radius-0 {
  border-radius: 0 !important;
}

.dropdown-item {
  font-size: 14px;
}

.btn-warning {
  color: #fff;
}
.btn-warning:hover {
  color: #fff;
}

.btn-outline-warning:hover {
  color: #fff;
}

.form-control {
  border-radius: 4px;
  border-color: #ebebee;
  font-size: 13px;
  box-shadow: none;
}
.form-control:focus {
  box-shadow: none;
  border-color: #2962ff;
}

.form-group .form-text {
  margin-top: 10px;
  font-size: 12px;
}
.form-group > label {
  text-transform: capitalize;
  font-weight: 500;
}

.form-check-input {
  margin-top: 2px;
}

.custom-control-label {
  padding-top: 4px;
}

.input-group-text {
  color: #fff;
  background-color: #2962ff;
  border-radius: 0;
}

.loader {
  top: 20px;
  position: absolute;
  left: 60%;
  text-align: center;
}

/* End Default style */
/* Helper class */
.fs-10 {
  font-size: 10px;
}

.fs-11 {
  font-size: 11px;
}

.fs-12 {
  font-size: 12px;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-15 {
  font-size: 15px;
}

.fs-18 {
  font-size: 18px;
}

.fs-20 {
  font-size: 20px;
}

.fs-22 {
  font-size: 22px;
}

.fs-40 {
  font-size: 40px;
}

.fs-50 {
  font-size: 50px;
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.mr-5 {
  margin-right: 5px !important;
}

.mr-10 {
  margin-right: 10px;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mt-40 {
  margin-top: 40px;
}

.mt-minus-1 {
  margin-top: -1px;
}

.mt-minus-2 {
  margin-top: -2px;
}

.mt-minus-3 {
  margin-top: -3px;
}

.mt-minus-4 {
  margin-top: -4px;
}

.mt-minus-5 {
  margin-top: -5px;
}

.pr-70 {
  padding-right: 70px;
}

.p-30 {
  padding: 30px;
}

.fr {
  float: right;
}

.wh-13 {
  width: 13px;
  height: 13px;
  margin-top: -2px;
}

.wh-15 {
  width: 15px;
  height: 15px;
}

.wh-30 {
  width: 30px;
  height: 30px;
}

.wh-35 {
  width: 35px;
  height: 35px;
}

.wh-40 {
  width: 40px;
  height: 40px;
}

.w-80 {
  width: 80px;
}

.w-full {
  width: 100%;
}

.mw-350 {
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}

.relative {
  position: relative;
}

.border {
  border: 1px solid #ebebee;
}

.black-text {
  color: #47404f !important;
}

.primary-text {
  color: #2962ff !important;
}

.purple-text {
  color: #7266ba !important;
}

.success-text {
  color: #7ed320 !important;
}

.danger-text {
  color: #f75d81 !important;
}

.theme-color {
  color: #2962ff;
}

.danger-color {
  color: #f75d81;
}

.global-color {
  color: #47404f;
}

.gray-color {
  color: #a1aab2;
}

.light-blue-bg {
  background: #42a5f6;
}

.purple-bg {
  background: #7266ba;
}

.primary-bg {
  background: #2962ff;
}

.success-bg {
  background: #7ed320;
}

.danger-bg {
  background: #f75d81;
}

.theme-bg {
  background-color: #2962ff !important;
}

.right {
  right: 0;
}

.bottom {
  bottom: 0;
}

.right-3 {
  right: 3px;
}

.bottom-2 {
  bottom: 2px;
}

.bottom-3 {
  bottom: 3px;
}

.d-table {
  width: 100%;
  height: 100%;
}

.d-tablecell {
  display: table-cell;
  vertical-align: middle;
}

.line-height-1 {
  line-height: 1;
}

.bg-white {
  background-color: #fff !important;
}

.border-radius-fl-item .page-item:first-child .page-link {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.border-radius-fl-item .page-item:last-child .page-link {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.height-408 {
  height: 408px;
  overflow-y: auto;
}

.height-310 {
  height: 310px;
  overflow-y: auto;
}

.height-500 {
  height: 500px;
  overflow-y: auto;
}

.rounded {
  border-radius: 50px !important;
}

.alert-light {
  background-color: #f9f9f9;
  border-color: #f9f9f9;
}

.alert:last-child {
  margin-bottom: 0;
}

.alert-dismissible .close {
  padding: 0.6rem 1.2rem;
}

.white-color {
  color: #fff;
}

.card-img-overlay {
  background: rgba(41, 98, 255, 0.5);
}
.card-img-overlay .card-title {
  color: #fff !important;
}

.alert-success p {
  color: #155724;
}

.dropdown-menu {
  border-radius: 0;
}
.dropdown-menu .dropdown-item {
  font-size: 13px;
  color: #797979;
}

.badge-warning {
  color: #fff;
}

.btn-primary {
  background-color: #2962ff;
  border-color: #2962ff;
}
.btn-primary:hover {
  background-color: #2962ff;
  border-color: #2962ff;
  opacity: 0.7;
}

.btn-outline-primary {
  color: #2962ff;
  border-color: #2962ff;
}
.btn-outline-primary:hover {
  background-color: #2962ff;
  border-color: #2962ff;
}

/* End helper class */
/* Main content style */
.main-content {
  width: 100%;
  margin-top: 62px;
  transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  padding: 30px 30px 0;
  position: relative;
  min-height: calc(100vh - 62px);
  padding-left: 244px;
  overflow: hidden;
}

/* End main content style */
/* Dashboard landing page v.1 style */
.main-content-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #ebebee;
  padding-bottom: 10px;
}
.main-content-header h1 {
  margin: 0;
  font-size: 18px;
  padding-right: 15px;
}
.main-content-header .breadcrumb {
  padding: 0;
  margin-bottom: 0;
  background-color: transparent;
}
.main-content-header .breadcrumb .breadcrumb-item {
  margin-top: 1px;
}
.main-content-header .breadcrumb a {
  color: #47404f;
  text-decoration: none;
}
.main-content-header .breadcrumb a:hover {
  color: #2962ff;
}

.single-sales-card .card-body {
  padding: 0 !important;
}
.single-sales-card .card-body .icon {
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
  width: 80px;
  height: 80px;
  padding: 22px;
  border-radius: 4px 0 0 4px;
}
.single-sales-card .card-body .content p {
  color: #fff;
  line-height: 1;
}

.card {
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
  border-radius: 4px;
  border: medium none currentColor;
  border: initial;
}
.card .card-body {
  padding: 20px;
}
.card .card-header {
  background-color: transparent;
  padding: 0;
  border-bottom: 1px solid #ebebee;
  position: relative;
  margin-bottom: 20px;
}
.card .card-header::before {
  content: "";
  background: #2962ff;
  height: 1px;
  width: 30px;
  position: absolute;
  left: 0;
  bottom: -1px;
}
.card .card-header .day {
  background-color: #2962ff;
  position: absolute;
  bottom: 2px;
  right: 0;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  padding: 5px 10px 5px 22px;
  clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 16% 50%, 0% 0%);
}
.card .card-title {
  font-size: 15px;
  padding-bottom: 10px;
  padding: 0;
  color: #323332;
}
.card .header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  color: inherit;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  font-weight: 600;
}
.card .header::before {
  right: 0;
  margin: auto;
}
.card .content {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 120px;
}

.card-dropdown .btn {
  border-radius: 30px;
  font-size: 15px;
  padding: 0;
  line-height: 25px;
  background: #fff;
  color: #2962ff;
  height: 25px;
  width: 25px;
  margin-top: -5px;
}
.card-dropdown .btn .icon {
  width: 18px;
  height: 18px;
}
.card-dropdown .btn:hover {
  background: #2962ff;
  color: #fff;
}
.card-dropdown .btn:after {
  display: none;
}
.card-dropdown .dropdown-menu.show {
  left: auto !important;
  right: 0 !important;
  transform: inherit !important;
  top: 24px !important;
  border-radius: 0;
}
.card-dropdown .dropdown-item {
  font-size: 13px;
  padding: 0.4rem 1rem;
  white-space: pre-wrap;
  font-weight: 300;
}
.card-dropdown .dropdown-item.active, .card-dropdown .dropdown-item:active {
  color: #16181b;
  background-color: #f8f9fa;
}

.card-header .select-month-form {
  position: absolute;
  right: 0;
  bottom: -1px;
}
.card-header .select-month-form .form-control {
  height: 30px;
}

.hover-card {
  transition: all 0.3s ease;
}
.hover-card:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 15px 25px rgba(60, 50, 100, 0.1);
}

/* stats card */
.stats-card {
  background-color: #fff;
  padding: 20px;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
}
.stats-card h3 {
  margin: 0;
  font-size: 22px;
}
.stats-card h3 .icon {
  margin-left: 5px;
  width: 18px;
  height: 18px;
  margin-top: -4px;
}
.stats-card p {
  margin: 5px 0 0;
  line-height: 1;
}
.stats-card i {
  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  height: 50px;
  width: 50px;
  border-radius: 30px 0 30px 30px;
  transition: 0.5s;
  text-align: center;
  line-height: 50px;
  font-size: 25px;
}
.stats-card:hover i {
  height: 100%;
  border-radius: 0 4px 4px 0;
  width: 70px;
  line-height: 85px;
  font-size: 35px;
}
.stats-card:hover .icon-hover {
  height: 60px;
  width: 60px;
  line-height: 60px;
  border-radius: 30px 0 30px 30px;
  font-size: 30px;
}
.stats-card .stats-icon {
  position: absolute;
  right: 0;
  top: 0;
  color: #fff;
  height: 50px;
  width: 50px;
  padding: 10px;
  border-radius: 30px 0 30px 30px;
  transition: 0.5s;
}
.stats-card:hover .stats-icon {
  height: 100%;
  border-radius: 0 4px 4px 0;
  width: 70px;
  padding: 15px;
}

.purple-card h3 .icon {
  color: #7266ba;
}
.purple-card .stats-icon {
  background: #7266ba;
}
.purple-card i {
  background: #7266ba;
}
.purple-card .progress .progress-bar {
  background-color: #7266ba !important;
}

.light-blue-card h3 .icon {
  color: #42a5f6;
}
.light-blue-card .stats-icon {
  background: #42a5f6;
}
.light-blue-card i {
  background: #42a5f6;
}
.light-blue-card .progress .progress-bar {
  background-color: #42a5f6 !important;
}

.success-card h3 .icon {
  color: #7ed320;
}
.success-card .stats-icon {
  background: #7ed320;
}
.success-card i {
  background: #7ed320;
}
.success-card .progress .progress-bar {
  background-color: #7ed320 !important;
}

.danger-card h3 .icon {
  color: #f75d81;
}
.danger-card .stats-icon {
  background: #f75d81;
}
.danger-card i {
  background: #f75d81;
}
.danger-card .progress .progress-bar {
  background-color: #f75d81 !important;
}

/* End stats card */
.top-rated-products {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.top-rated-products .single-product {
  border-bottom: 1px solid #ebebee;
  position: relative;
  padding-left: 80px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 45px;
}
.top-rated-products .single-product img {
  border: 1px solid #f3f3f3;
  width: 65px;
  height: 65px;
  position: absolute;
  left: 0;
  top: 14px;
}
.top-rated-products .single-product .product-title {
  font-size: 13px;
  color: #47404f;
  font-weight: 500;
  line-height: 1;
  text-decoration: none;
}
.top-rated-products .single-product .product-title:hover {
  color: #2962ff;
}
.top-rated-products .single-product p {
  margin: 0 0 5px;
}
.top-rated-products .single-product .rating {
  line-height: 0;
}
.top-rated-products .single-product .rating span {
  color: #ffce00;
  margin-right: 5px;
}
.top-rated-products .single-product .view-link {
  position: absolute;
  top: 30px;
  right: 10px;
  border: 1px solid #2962ff;
  color: #2962ff;
  height: 30px;
  width: 30px;
  text-align: center;
  display: inline-block;
  line-height: 30px;
  border-radius: 30px;
}
.top-rated-products .single-product .view-link:hover {
  background: #2962ff;
  color: #fff;
}

.tickets-lists {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: 365px;
  overflow-y: auto;
}
.tickets-lists li {
  border-bottom: 1px solid #ebebee;
  position: relative;
  padding-left: 65px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 40px;
}
.tickets-lists li img {
  border: 1px solid #f3f3f3;
  width: 50px;
  height: 50px;
  position: absolute;
  left: 0;
  top: 11px;
}
.tickets-lists li .product-title {
  font-size: 13px;
  color: #47404f;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 3px;
  text-decoration: none;
}
.tickets-lists li .product-title:hover {
  color: #2962ff;
}
.tickets-lists li .date, .tickets-lists li .time {
  color: #797979;
}
.tickets-lists li .date .icon, .tickets-lists li .time .icon {
  width: 10px;
  height: 10px;
}

.height-365 {
  height: 365px;
  overflow-y: auto;
}

.product-categories {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.product-categories li {
  line-height: 25px;
  position: relative;
  padding-left: 16px;
}
.product-categories li::before {
  content: "";
  border: 1.4px solid #2962ff;
  width: 10px;
  height: 10px;
  position: absolute;
  left: 0;
  top: 7px;
  border-radius: 50px;
}
.product-categories li a {
  color: #797979;
  text-decoration: none;
}
.product-categories li a:hover {
  color: #2962ff;
}

.table thead {
  background: #f3f6f9;
}
.table .bg-none {
  background: none;
}
.table .border-none th {
  border-top: none;
  padding-top: 0;
}
.table th {
  font-size: 13px;
}
.table th, .table td {
  border-bottom: 1px solid #eee;
}
.table td {
  color: #797979;
}
.table .badge {
  font-weight: 500;
  padding: 5px 7px;
}
.table a {
  color: #797979;
  text-decoration: none;
}
.table a:hover {
  color: #2962ff;
}
.table tr.active {
  background: #f3f6f9;
}

.table > :not(caption) > * > * {
  padding: 11px 0.5rem;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fff;
}
.table-striped tbody tr:nth-of-type(even) {
  background-color: #f3f6f9;
}

.table-hover tbody tr:hover {
  background-color: #f3f6f9;
}

.table-dark thead {
  background: #212529;
}
.table-dark td {
  color: #fff;
}

/* End dashboard landing page v.1 style */
/* Search result style */
.search-result .single-product {
  border: 1px solid #ebebee;
  padding-left: 100px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 45px;
  margin-top: 20px;
  border-radius: 6px;
}
.search-result .single-product img {
  left: 20px;
  top: 18px;
}
.search-result .single-product .view-link {
  top: 35px;
  right: 20px;
}

.page-link {
  color: #2962ff;
}
.page-link:hover {
  color: #000;
}

.page-item.active .page-link {
  background-color: #2962ff;
  border-color: #2962ff;
}

/* End search result style */
/* Notifications page style */
.notifications-card .noti-card-title {
  background: #fff;
  margin: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebebee;
  border-left: 1px solid #ebebee;
  border-right: 1px solid #ebebee;
  font-size: 15px;
}
.notifications-card .list-group .list-group-item {
  border: 1px solid #ebebee;
  padding: 15px 15px 15px 40px;
  position: relative;
  font-size: 13px;
}
.notifications-card .list-group .list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.notifications-card .list-group .list-group-item a {
  font-weight: 500;
  color: #2962ff;
  text-decoration: none;
}
.notifications-card .list-group .list-group-item a:hover {
  text-decoration: underline;
}
.notifications-card .list-group .list-group-item .icon {
  position: absolute;
  left: 15px;
  top: 16px;
  width: 16px;
  height: 16px;
}
.notifications-card .list-group .list-group-item span {
  position: absolute;
  left: 15px;
  top: 15px;
  font-size: 18px;
}
.notifications-card .list-group .list-group-item .time {
  position: absolute;
  right: 15px;
  top: 17px;
  color: #a1aab2;
  font-size: 13px;
}
.notifications-card .list-group .list-group-item ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.notifications-card .list-group .list-group-item ul li {
  display: inline-block;
  margin-right: 5px;
  margin-top: 5px;
}
.notifications-card .list-group .list-group-item .content {
  padding-top: 10px;
}
.notifications-card .list-group .list-group-item .media {
  padding: 15px;
  border: 1px solid #ebebee;
  border-radius: 5px;
}

.status {
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.online {
  background: #42b72a;
}

.ofline {
  background: #f62d51;
}

.away {
  background: #ffbc34;
}

/* End Notifications page style */
.notification-card-one a {
  text-decoration: none;
}

/* Todo list style */
.todo-list ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.todo-list ul li {
  position: relative;
  border: 1px solid #ebebee;
  padding: 15px 40px 15px 45px;
  border-radius: 10px;
  margin-top: 10px;
}
.todo-list ul li .task {
  font-size: 14px;
}
.todo-list ul li .completed {
  text-decoration: line-through;
  color: cadetblue;
}
.todo-list ul .close-btn {
  background-color: transparent;
  color: #f75d81;
  position: absolute;
  right: 15px;
  top: 15px;
  padding: 0;
  height: 22px;
  width: 22px;
  font-size: 9px;
  border-radius: 50%;
  line-height: 22px;
}
.todo-list .add-new-task {
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}
.todo-list .add-new-task .form-control {
  border-color: #ebebee;
  border-radius: 0;
  background: #eef5f9;
  height: 42px;
  box-shadow: none;
}
.todo-list .add-new-task .btn-primary {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0;
  height: 42px;
}

.control {
  display: block;
  position: absolute;
  cursor: pointer;
  left: 15px;
  top: 12px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control .control-indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 22px;
  width: 22px;
  border: 1px solid #e6e6e6;
  border-radius: 50%;
}

.control input:checked ~ .control-indicator {
  background: #2962ff;
}

.control-indicator:after {
  content: "";
  position: absolute;
  display: none;
}

.control input:checked ~ .control-indicator:after {
  display: block;
}

.control-checkbox .control-indicator:after {
  left: 7px;
  top: 3px;
  width: 6px;
  height: 11px;
  border: 1px solid #e6e6e6;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* End Todo list style */
/* Signup page style */
.auth-main-content {
  height: 100vh;
  padding: 0 15px;
}

.auth-box {
  max-width: 750px;
  margin: 30px auto;
  background: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
  padding-left: 15px;
  padding-right: 15px;
}
.auth-box::before {
  content: "";
  position: absolute;
  background: #ebebee;
  height: 100%;
  width: 1px;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
}

.form-left-content {
  padding: 50px 30px 50px 30px;
}
.form-left-content .auth-logo {
  text-align: center;
  font-size: 25px;
  color: #2962ff;
  line-height: 1;
}
.form-left-content .login-links a {
  display: block;
  margin-top: 15px;
  line-height: 1;
  padding: 8px 15px;
  border-radius: 30px;
  text-align: center;
  text-decoration: none;
}
.form-left-content .login-links a .icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-top: -2px;
}
.form-left-content .login-links a span {
  padding-right: 5px;
}
.form-left-content .login-links .fb {
  background: #3B5998;
  color: #fff;
  border: 1px solid #3B5998;
}
.form-left-content .login-links .fb:hover {
  border-radius: 0;
}
.form-left-content .login-links .twi {
  border: 1px solid #3CF;
  background: #3CF;
  color: #fff;
}
.form-left-content .login-links .twi:hover {
  border-radius: 0;
}
.form-left-content .login-links .ema {
  border: 1px solid #DC4A38;
  background: #DC4A38;
  color: #fff;
}
.form-left-content .login-links .ema:hover {
  border-radius: 0;
}
.form-left-content .login-links .linkd {
  border: 1px solid #007bb6;
  background: #007bb6;
  color: #fff;
}
.form-left-content .login-links .linkd:hover {
  border-radius: 0;
}

.form-content {
  padding: 50px 30px 50px 30px;
}
.form-content .heading {
  margin: 0 0 20px;
  position: relative;
  font-size: 18px;
  border-bottom: 1px solid #ebebee;
  padding-bottom: 8px;
  font-weight: 600;
}
.form-content .heading::before {
  content: "";
  background: #2962ff;
  height: 1px;
  width: 30px;
  position: absolute;
  left: 0;
  bottom: -1px;
}
.form-content .form-control {
  height: 35px;
  border-radius: 30px;
  border: 1px solid #ebebeb;
}
.form-content .btn-primary {
  border-radius: 30px;
  font-size: 13px;
  padding: 10px 20px;
  line-height: 1;
  width: 100%;
}
.form-content .fp-link {
  display: block;
  margin-top: 15px;
  max-width: 120px;
  margin-left: auto;
  margin-right: auto;
  color: #47404f;
}
.form-content .fp-link:hover {
  color: #2962ff;
  text-decoration: underline;
}

.auth-bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
}

/* End signup page style */
/* Notes page style */
.notes-card {
  position: relative;
}
.notes-card button {
  background: #f75d81;
  border-color: #f75d81;
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  font-size: 10px;
  border-radius: 0;
}

.notes-content .form-control {
  border-radius: 0;
  border-color: #ebebee;
  box-shadow: none;
  padding: 15px;
  line-height: 26px;
}
.notes-content form {
  position: relative;
}
.notes-content form .btn {
  position: absolute;
  top: 0;
  right: 0;
}

/* End notes page style */
/* Map style */
.map-content {
  width: 100%;
  height: 500px;
}

/* End map style */
/* Calendar style */
.react-calendar {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #e3e3e3;
}
.react-calendar button span {
  font-weight: 600;
  font-size: 15px;
}
.react-calendar .react-calendar__month-view__weekdays {
  font-size: 13px;
}
.react-calendar .react-calendar__tile {
  font-size: 14px;
  border: 1px solid #eee !important;
  padding: 30px 8px;
}

/* End Calendar style */
/* List group */
.card-header + .list-group .list-group-item:first-child {
  border-top: 1px solid #ebebeb;
  border-radius: 0;
}

.list-group-item:last-child {
  border-radius: 0;
}

/* End List group */
/* Modal style */
.modal-dialog .modal-content {
  border-radius: 0;
}
.modal-dialog .modal-content .modal-header {
  padding: 20px 30px;
}
.modal-dialog .modal-content .modal-header .modal-title {
  font-size: 22px;
  line-height: 1;
}
.modal-dialog .modal-content .modal-body {
  padding: 30px;
}
.modal-dialog .modal-content .modal-footer {
  padding: 20px 30px;
}
.modal-dialog p {
  line-height: 25px;
}

.modal-90w {
  width: 90%;
  max-width: none !important;
}

/* End Modal style */
/* Tab style */
.tab-content p {
  margin-bottom: 10px;
}
.tab-content p:last-child {
  margin: 0;
}

.tabs-style-one .tab-content {
  padding: 20px;
  border-bottom: 1px solid #ebebee;
  border-left: 1px solid #ebebee;
  border-right: 1px solid #ebebee;
}
.tabs-style-one .nav-tabs .nav-link {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  color: #495057;
}

.tabs-style-two .tab-content {
  padding: 20px;
  border-bottom: 1px solid #ebebee;
  border-left: 1px solid #ebebee;
  border-right: 1px solid #ebebee;
}
.tabs-style-two .nav-tabs .nav-link {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  color: #495057;
}
.tabs-style-two .nav-tabs .nav-link.active, .tabs-style-two .nav-tabs .nav-item.show .nav-link {
  color: #fff;
  background-color: #2962ff;
  border-color: #2962ff;
}

.tabs-style-three .tab-content {
  padding: 20px;
  border-bottom: 1px solid #ebebee;
  border-left: 1px solid #ebebee;
  border-right: 1px solid #ebebee;
}
.tabs-style-three .nav-tabs .nav-link {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  color: #495057;
  border-top: 2px solid transparent;
}
.tabs-style-three .nav-tabs .nav-link:hover {
  border-top: 2px solid #2962ff;
  border-bottom-color: #fff;
}
.tabs-style-three .nav-tabs .nav-link.active, .tabs-style-three .nav-tabs .nav-item.show .nav-link {
  border-top: 2px solid #2962ff;
}

.pill-tab .nav {
  border-bottom: 1px solid #ebebee;
}
.pill-tab .nav-pills .nav-link {
  border-radius: 0;
  color: #495057;
}
.pill-tab .nav-pills .nav-link:hover {
  color: #2962ff;
}
.pill-tab .nav-pills .nav-link.active, .pill-tab .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #797979;
}
.pill-tab .tab-content {
  margin-top: 20px;
}

.vertical-pills-tab .nav-pills .nav-link {
  border-radius: 0;
  color: #495057;
}
.vertical-pills-tab .nav-pills .nav-link:hover {
  color: #2962ff;
}
.vertical-pills-tab .nav-pills .nav-link.active, .vertical-pills-tab .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #2962ff;
}

/* End Tab style */
/* Inbox style */
.inbox-main-sidebar .nav-pills {
  margin-top: 20px;
}
.inbox-main-sidebar .nav-pills .nav-link {
  border-radius: 0px;
  color: #47404f;
}
.inbox-main-sidebar .nav-pills .nav-link:hover {
  color: #2962ff;
  background-color: #fff;
}
.inbox-main-sidebar .nav-pills .nav-link.active {
  color: #2962ff;
  background-color: #fff;
}

.inbox-content-wrap {
  background: #fff;
}

textarea.form-control {
  line-height: 22px;
}

.mail-item-nav {
  border-right: 1px solid #eee;
  height: 720px;
  overflow-y: auto;
}
.mail-item-nav .nav-pills .nav-link {
  border-radius: 0;
  border-bottom: 1px solid #eee;
  padding: 20px 15px;
  position: relative;
  overflow: hidden;
}
.mail-item-nav .nav-pills .nav-link:hover {
  background-color: #fafafa;
}
.mail-item-nav .nav-pills .nav-link:hover::before {
  content: "";
  position: absolute;
  right: -18px;
  background: #2962ff;
  height: 15px;
  width: 40px;
  transform: rotate(-45deg);
  bottom: 0;
}
.mail-item-nav .nav-pills .nav-link img {
  position: absolute;
}
.mail-item-nav .nav-pills .nav-link .info {
  padding-left: 40px;
}
.mail-item-nav .nav-pills .nav-link .info .name {
  line-height: 1;
  color: #70657b;
  font-size: 13px;
  font-weight: 500;
}
.mail-item-nav .nav-pills .nav-link .info p {
  color: #47404f;
  margin: 6px 0 0;
  line-height: 1;
  font-size: 12px;
}
.mail-item-nav .nav-pills .nav-link .info .date {
  right: 15px;
  position: absolute;
  top: 20px;
  color: #797979;
  font-size: 11px;
  line-height: 1;
}
.mail-item-nav .nav-pills .nav-link.active {
  background-color: #fafafa;
}
.mail-item-nav .nav-pills .nav-link.active::before {
  content: "";
  position: absolute;
  right: -18px;
  background: #2962ff;
  height: 15px;
  width: 40px;
  transform: rotate(-45deg);
  bottom: 0;
}

.email-details-warp {
  height: 720px;
  overflow-y: auto;
  padding: 30px 30px 30px 0;
  position: relative;
}
.email-details-warp p {
  color: #797979;
  font-size: 13px;
}
.email-details-warp .inbox-topbar {
  position: absolute;
  top: 30px;
  right: 30px;
}
.email-details-warp .inbox-topbar .btn {
  border-radius: 30px;
  padding: 5px 10px;
  font-size: 10px;
}

/* End Inbox style */
/* Marketing content */
.marketing-content .list {
  position: relative;
  padding-left: 50px;
  margin-bottom: 11px;
  border-bottom: 1px solid #eee;
  padding-bottom: 11px;
}
.marketing-content .list:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}
.marketing-content .list > .icon {
  width: 35px;
  height: 35px;
  color: #fff;
  padding: 8px;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 2px;
}
.marketing-content .list .fb {
  background: #4267b2;
}
.marketing-content .list .ins {
  background: #A1755C;
}
.marketing-content .list .twi {
  background: #1da1f2;
}
.marketing-content .list .lin {
  background: #0077B5;
}
.marketing-content .list .ytb {
  background: #ff0000;
}
.marketing-content .list h3 {
  margin: 0;
  font-size: 13px;
}
.marketing-content .list h3 a {
  color: #47404f;
  text-decoration: none;
}
.marketing-content .list h3 a:hover {
  color: #2962ff;
}
.marketing-content .list p {
  margin: 7px 0 0;
  line-height: 1;
  font-size: 12px;
}
.marketing-content .list .stats {
  position: absolute;
  right: 0;
  top: 0;
}
.marketing-content .list .stats .icon {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}

/* End Marketing content */
/* New customer card */
.new-customer {
  position: relative;
  padding-left: 52px;
  padding-top: 5px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.new-customer:last-child {
  margin-bottom: 0;
}
.new-customer a {
  text-decoration: none;
}
.new-customer .profile {
  position: absolute;
  left: 0;
  top: 0;
}
.new-customer .profile img {
  width: 40px;
  height: 40px;
}
.new-customer .price {
  position: absolute;
  right: 0;
  top: 8px;
  font-size: 14px;
  font-weight: 500;
}

/* End new customer card */
/* Search contact */
.search-contact {
  padding: 15px;
  border-bottom: 1px solid #eee;
}
.search-contact .form-control {
  height: 41px;
}

.chat-header {
  border-bottom: 1px solid #eee;
  padding: 8px 0;
  margin-right: 30px;
}

.chat-details-warp {
  padding: 30px 30px 110px 0;
}

.chat-list-right {
  position: relative;
  padding-right: 60px;
  margin-bottom: 20px;
}
.chat-list-right > img {
  position: absolute;
  right: 0;
  top: 0;
}
.chat-list-right .chat-details {
  background: #fafafa;
  position: relative;
  padding: 20px 20px 10px;
}
.chat-list-right .chat-details::before {
  position: absolute;
  content: "";
  top: 14px;
  right: -5px;
  background: 0 0;
  border-style: solid;
  border-width: 0 12px 12px 0;
  border-color: transparent transparent #fafafa;
  transform: rotate(-135deg);
}
.chat-list-right .chat-details .name {
  font-size: 15px;
}
.chat-list-right .chat-details .date {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #797979;
  font-size: 12px;
}

.chat-list-left {
  position: relative;
  padding-left: 60px;
  margin-bottom: 20px;
}
.chat-list-left > img {
  position: absolute;
  left: 0;
  top: 0;
}
.chat-list-left .chat-details {
  background: #fafafa;
  position: relative;
  padding: 20px 20px 10px;
}
.chat-list-left .chat-details::before {
  position: absolute;
  content: "";
  top: 14px;
  left: -5px;
  background: 0 0;
  border-style: solid;
  border-width: 0 12px 12px 0;
  border-color: transparent transparent #fafafa;
  transform: rotate(45deg);
}
.chat-list-left .chat-details .name {
  font-size: 15px;
}
.chat-list-left .chat-details .date {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #797979;
  font-size: 12px;
}

.chat-box {
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-right: 30px;
  padding-bottom: 30px;
}

/* End Search contact */
/* Order stats card */
.order-stats-card {
  position: relative;
}
.order-stats-card h3 {
  margin: 0;
  font-size: 13px;
}

.order-number-stats {
  text-align: center;
}
.order-number-stats .number {
  font-weight: 500;
  font-size: 18px;
}
.order-number-stats p {
  margin: 0;
  line-height: 1;
}

/* End order stats card */
/* Visitor stats card */
.visitor-stats {
  background-color: #fff;
  padding: 20px;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
  text-align: center;
}
.visitor-stats h3 {
  margin: 0;
  font-size: 22px;
}
.visitor-stats p {
  margin: 5px 0 10px;
  line-height: 1;
}
.visitor-stats p .icon {
  width: 15px;
  height: 15px;
  margin: 0 5px;
}

/* End visitor stats card */
/* Profile page style */
.profile-header {
  background-color: #fff;
  padding: 30px;
  text-align: center;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
  border-radius: 4px;
}
.profile-header .name {
  margin: 0;
  font-size: 18px;
}
.profile-header p {
  margin: 5px auto 0;
  max-width: 690px;
  line-height: 22px;
}
.profile-header .profile-stats a {
  display: inline-block;
  margin-top: 10px;
  margin-left: 8px;
  margin-right: 8px;
  color: #797979;
  text-decoration: none;
}
.profile-header .profile-stats a strong {
  color: #000;
}
.profile-header .profile-stats a:hover strong {
  color: #2962ff;
}

.profile-left-content .info {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.profile-left-content .info li {
  line-height: 22px;
  position: relative;
  color: #797979;
  padding-left: 20px;
  margin-bottom: 10px;
}
.profile-left-content .info li:last-child {
  margin-bottom: 0;
}
.profile-left-content .info li .icon {
  width: 14px;
  height: 14px;
  color: #000;
  position: absolute;
  left: 0;
  top: 3px;
}

.profile-middle-content {
  background-color: #fff;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
  border-radius: 4px;
}

.post-card {
  padding: 20px;
  border-bottom: 1px solid #eee;
}
.post-card .content h5 {
  font-size: 15px;
  margin-bottom: 5px;
  line-height: 22px;
}
.post-card .content h5 a {
  color: #47404f;
  text-decoration: none;
}
.post-card .content h5 a:hover {
  color: #2962ff;
}
.post-card .content p {
  margin: 0 0 10px;
}
.post-card .feed-back a {
  color: #797979;
  margin-right: 15px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  text-decoration: none;
}
.post-card .feed-back a:hover {
  color: #2962ff;
}
.post-card .feed-back a:last-child {
  border-right: none;
  padding-right: 0;
}
.post-card .feed-back a .icon {
  width: 17px;
  height: 17px;
  margin-right: 5px;
  margin-top: -2px;
}

.profile-right-content .connecting-list {
  height: 255px;
  overflow-x: hidden;
}
.profile-right-content .list-content {
  border-bottom: 1px solid #eee;
  margin-bottom: 12px;
  padding-bottom: 12px;
}
.profile-right-content .list-content:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}
.profile-right-content .list-content h5 {
  margin: 0 0 8px;
  font-size: 12px;
}
.profile-right-content .list-content h5 a {
  color: #47404f;
  text-decoration: none;
}
.profile-right-content .list-content h5 a:hover {
  color: #2962ff;
}
.profile-right-content .list-content .btn {
  font-size: 10px;
  padding: 5px 12px;
}

/* Profile page style */
.profile-settings-form {
  padding: 30px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
  max-width: 800px;
  margin: auto;
}

/* Users card */
.single-user-card {
  background-color: #fff;
  text-align: center;
  border-radius: 4px;
  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);
}
.single-user-card img {
  background-color: #e0e0e0;
  height: 120px;
  width: 120px;
}
.single-user-card h4 {
  font-size: 18px;
}
.single-user-card .social-links a {
  display: inline-block;
  margin: 0 5px;
  color: #797979;
}
.single-user-card .social-links a:hover {
  color: #2962ff;
}
.single-user-card .social-links a .icon {
  width: 15px;
  height: 15px;
}
.single-user-card .user-card-foot {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #eee;
}
.single-user-card .user-card-foot li {
  display: inline-block;
  display: inline-block;
  width: 33.33%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  color: #797979;
}
.single-user-card .user-card-foot li span {
  display: block;
  font-weight: 500;
  font-size: 18px;
  color: #47404f;
}
.single-user-card .user-card-foot .bor-lr {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.octagon-style {
  clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
}

.nonagon-style {
  clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);
}

.bevel-style {
  clip-path: polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);
}

/* End Users card */
/* TimeLine Style */
.timeline-centered {
  position: relative;
  margin-bottom: 30px;
}
.timeline-centered:before, .timeline-centered:after {
  content: "";
  display: table;
}
.timeline-centered:after {
  clear: both;
}
.timeline-centered:before {
  content: "";
  position: absolute;
  display: block;
  width: 4px;
  background: #fff;
  left: 50%;
  top: 20px;
  bottom: 20px;
  margin-left: -4px;
}
.timeline-centered .timeline-card {
  position: relative;
  width: 50%;
  float: right;
  margin-bottom: 40px;
  clear: both;
}
.timeline-centered .timeline-card:before, .timeline-centered .timeline-card:after {
  content: " ";
  display: table;
}
.timeline-centered .timeline-card:after {
  clear: both;
}
.timeline-centered .timeline-card:before, .timeline-centered .timeline-card:after {
  content: " ";
  display: table;
}
.timeline-centered .timeline-card:after {
  clear: both;
}
.timeline-centered .timeline-card.begin {
  margin-bottom: 0;
}
.timeline-centered .timeline-card.left-aligned {
  float: left;
}
.timeline-centered .timeline-card.left-aligned .timeline-body {
  margin-left: 0;
  margin-right: -18px;
}
.timeline-centered .timeline-card.left-aligned .timeline-body .time {
  left: auto;
  right: -100px;
  text-align: left;
}
.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-icon {
  float: right;
}
.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-label {
  margin-left: 0;
  margin-right: 70px;
}
.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-label:after {
  left: auto;
  right: 0;
  margin-left: 0;
  margin-right: -9px;
  transform: rotate(180deg);
}
.timeline-centered .timeline-card .timeline-body {
  position: relative;
  margin-left: -22px;
}
.timeline-centered .timeline-card .timeline-body:before, .timeline-centered .timeline-card .timeline-body:after {
  content: " ";
  display: table;
}
.timeline-centered .timeline-card .timeline-body:after {
  clear: both;
}
.timeline-centered .timeline-card .timeline-body:before, .timeline-centered .timeline-card .timeline-body:after {
  content: " ";
  display: table;
}
.timeline-centered .timeline-card .timeline-body:after {
  clear: both;
}
.timeline-centered .timeline-card .timeline-body .time {
  position: absolute;
  left: -100px;
  text-align: right;
}
.timeline-centered .timeline-card .timeline-body .time > span {
  display: block;
}
.timeline-centered .timeline-card .timeline-body .time > span:first-child {
  font-size: 15px;
  font-weight: 500;
}
.timeline-centered .timeline-card .timeline-body .time > span:last-child {
  font-size: 12px;
  color: #797979;
}
.timeline-centered .timeline-card .timeline-body .timeline-icon {
  background: #fff;
  color: #737881;
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  text-align: center;
  box-shadow: 0 0 0 4px #fff;
  line-height: 40px;
  font-size: 15px;
  float: left;
}
.timeline-centered .timeline-card .timeline-body .timeline-label {
  position: relative;
  background: #fff;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
  padding: 1.7em;
  margin-left: 70px;
  border-radius: 4px;
}
.timeline-centered .timeline-card .timeline-body .timeline-label:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  left: 0;
  top: 10px;
  margin-left: -9px;
}
.timeline-centered .timeline-card .timeline-body .timeline-label h3 {
  font-size: 18px;
  margin-bottom: 5px;
  line-height: 25px;
}
.timeline-centered .timeline-card .timeline-body .timeline-label p {
  margin-top: 5px;
  margin-bottom: 0;
}

.timeline-icon.bg-purple {
  background-color: #7266ba !important;
  color: #fff;
}
.timeline-icon.bg-purple .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-primary {
  background-color: #2962ff;
  color: #fff;
}
.timeline-icon.bg-primary .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-secondary {
  background-color: #ee4749;
  color: #fff;
}
.timeline-icon.bg-secondary .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-success {
  background-color: #7ed320;
  color: #fff;
}
.timeline-icon.bg-success .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-info {
  background-color: #21a9e1;
  color: #fff;
}
.timeline-icon.bg-info .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-warning {
  background-color: #fad839;
  color: #fff;
}
.timeline-icon.bg-warning .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

.timeline-icon.bg-danger {
  background-color: #f75d81;
  color: #fff;
}
.timeline-icon.bg-danger .icon {
  color: #fff;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}

/* End TimeLine Style */
/* Invoice Template */
.invoice-template {
  background: #fff;
  padding: 20px;
}
.invoice-template .invoice-header {
  position: relative;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
.invoice-template .invoice-header h3 {
  margin: 0;
  font-size: 20px;
  text-transform: uppercase;
}
.invoice-template .invoice-header p {
  color: #47404f;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 500;
  font-size: 18px;
}

/* End Invoice Template */
/* Error page design */
.error-content {
  padding: 30px;
  text-align: center;
  height: 100vh;
}
.error-content .icon {
  width: 50px;
  height: 50px;
  color: #797979;
}
.error-content h1 {
  font-size: 100px;
  font-weight: bolder;
}
.error-content h3 {
  margin: 0;
}
.error-content p {
  margin: auto;
  max-width: 500px;
}
.error-content .back-link {
  background-color: #2962ff;
  color: #fff;
  display: inline-block;
  border: 1px solid #2962ff;
  padding: 10px 30px;
  border-radius: 100px;
  margin-top: 30px;
  text-decoration: none;
}
.error-content .back-link:hover {
  background-color: #333;
  border-color: #333;
}

/* End error page design */
/* Map Style */
.map-height-500 {
  height: 500px;
}

.jvectormap-container {
  padding: 20px;
}

/* End Map Style */
/* Apexcharts content */
.apexcharts-content {
  width: 100%;
}
.apexcharts-content .toolbar {
  margin-left: 45px;
}
.apexcharts-content .toolbar button {
  background: #fff;
  color: #222;
  border: 1px solid #e7e7e7;
  border-bottom: 2px solid #ddd;
  border-radius: 2px;
  padding: 4px 17px;
  cursor: pointer;
}
.apexcharts-content .toolbar button.active {
  color: #fff;
  background: #2962ff;
  border: 1px solid #2962ff;
  border-bottom: 2px solid #2962ff;
}

/* End Apexcharts content */
/* Accordion style  */
.custom-accordion .heading {
  margin-bottom: 20px;
  font-size: 20px;
}
.custom-accordion .accordion__item + .accordion__item {
  border-top: 1px solid #eee;
}
.custom-accordion .accordion__button {
  position: relative;
  background-color: #fff;
  padding: 20px;
  font-weight: 500;
  font-size: 17px;
}
.custom-accordion .accordion__button:focus {
  outline: 0;
}
.custom-accordion .accordion__button:hover {
  color: #2962ff;
}
.custom-accordion .accordion__button:before {
  float: right;
  margin-top: 7px;
}
.custom-accordion .accordion__panel {
  background-color: #fff;
  border-top: 1px solid #eee;
}
.custom-accordion .accordion__panel p {
  margin-bottom: 10px;
}
.custom-accordion .accordion__panel p:last-child {
  margin-bottom: 0;
}

/* End accordion style  */
/* Icon preview style */
.icon-preview {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  position: relative;
}
.icon-preview span {
  padding-left: 10px;
  font-size: 15px;
  color: #777;
  position: absolute;
  margin-top: 2px;
}

/* End Icon preview style */
/* Switch Button */
.side-menu-switch {
  position: absolute;
  top: 92px;
  right: 30px;
  z-index: 5;
}
.side-menu-switch .switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 26px;
}
.side-menu-switch .switch input {
  display: none;
}
.side-menu-switch .switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2c2f48;
  transition: 0.4s;
}
.side-menu-switch .switch .slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  background-color: white;
  top: 3px;
  transition: 0.4s;
  -webkit-transition: 0.4s;
}
.side-menu-switch .switch input.light:checked + .slider {
  background-color: #fff;
}
.side-menu-switch .switch input.light:checked + .slider:before {
  background-color: #2962ff;
}
.side-menu-switch .switch input:checked + .slider:before {
  transform: translateX(18px);
}
.side-menu-switch .switch .slider.round {
  border-radius: 30px;
  box-shadow: 0 0 8px #ddd;
}
.side-menu-switch .switch .slider.round:before {
  border-radius: 50%;
}

/* End Switch Button */
/* Pricing Table style */
.pricing-table {
  background: #fff;
  border-radius: 4px;
  text-align: center;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease 0s;
}
.pricing-table svg {
  display: block;
  margin-left: -1px;
}
.pricing-table .price {
  position: absolute;
  top: 0;
  color: #fff;
  font-size: 55px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  margin: 0;
  top: 50%;
  transform: translateY(-70%);
  -webkit-transform: translateY(-70%);
}
.pricing-table .price span {
  display: block;
  font-size: 15px;
  font-weight: 300;
  padding-left: 60px;
}
.pricing-table .pricing-content {
  padding: 40px 0 30px;
  position: relative;
}
.pricing-table .title {
  font-size: 25px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 0 10px 0;
}
.pricing-table .pricing-content ul {
  padding: 0;
  margin: 20px 0;
  list-style-type: none;
}
.pricing-table .pricing-content ul li {
  font-size: 15px;
  line-height: 40px;
  border-top: 1px solid #eee;
  color: #656565;
}
.pricing-table .signup {
  display: inline-block;
  padding: 8px 50px;
  border-radius: 20px;
  font-size: 18px;
  color: #fff;
  text-transform: uppercase;
  position: relative;
  transition: all 0.3s ease 0s;
}

/* End Pricing Table style */
/* Footer Style */
.footer {
  background: #fff;
  padding: 15px 30px;
  text-align: center;
  clip-path: polygon(1% 0, 99% 0, 100% 100%, 0% 100%);
  border-radius: 30px 30px 0 0;
}
.footer p {
  margin: 0;
  color: #5a5151;
}
.footer p a {
  color: #2962ff;
}
.footer p a:hover {
  text-decoration: underline;
}

/* End Footer Style */`, "",{"version":3,"sources":["webpack://./src/assets/css/style.scss","webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAmCA,mCAAA;AAcA,uCAAA;AAEA,kBAAA;AACA;EACI,yBAhBY;EAiBZ,cAhBkB;EAiBlB,eAAA;EACA,iCApBe;ACEnB;;ADoBA;EACI,gBAAA;EACA,wBAAA;ACjBJ;ADkBI;EACI,qBAAA;EACA,cAxBQ;ACQhB;;ADmBA;EACI,cA3Ba;EA4Bb,iBAAA;AChBJ;;ADkBA;EACI,eAAA;ACfJ;;ADiBA;EACI,iBAAA;ACdJ;;ADgBA;EACI,SAAA;ACbJ;;ADeA;EACI,eAAA;ACZJ;;ADeA,oBAAA;AACA;EACI,UAAA;EACA,WAAA;ACZJ;;ADcA;EACI,iCAAA;EACA,mBAAA;ACXJ;;ADaA;EACI,mBAAA;EACA,mBAvDY;EAwDZ,iCAAA;ACVJ;;ADYA;EACC,mBA3De;ACkDhB;;ADWA,wBAAA;AACA;EACI,UAAA;ACRJ;;ADUA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;ACPJ;;ADSA;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ACNJ;;ADQA;EACI,cAAA;ACLJ;;ADOA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;ACJJ;;ADMA;EACI,kBAAA;EACA,eAAA;ACHJ;;ADKA;EACI,iBAAA;EACA,eAAA;ACFJ;;ADIA;EACI,2BAAA;ACDJ;;ADGA;EACI,eAAA;ACAJ;;ADEA;EACI,WAAA;ACCJ;ADAI;EACI,WAAA;ACER;;ADEI;EACI,WAAA;ACCR;;ADEA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;ACCJ;ADAI;EACI,gBAAA;EACA,qBAtHQ;ACwHhB;;ADEI;EACI,gBAAA;EACA,eAAA;ACCR;ADCI;EACI,0BAAA;EACA,gBAAA;ACCR;;ADEA;EACI,eAAA;ACCJ;;ADCA;EACI,gBAAA;ACEJ;;ADAA;EACI,WAAA;EACA,yBA3IY;EA4IZ,gBAAA;ACGJ;;ADDA;EACI,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;ACIJ;;ADFA,sBAAA;AAEA,iBAAA;AACA;EACI,eAAA;ACIJ;;ADFA;EACI,eAAA;ACKJ;;ADHA;EACI,eAAA;ACMJ;;ADJA;EACI,eAAA;ACOJ;;ADLA;EACI,eAAA;ACQJ;;ADNA;EACI,eAAA;ACSJ;;ADPA;EACI,eAAA;ACUJ;;ADRA;EACI,eAAA;ACWJ;;ADTA;EACI,eAAA;ACYJ;;ADVA;EACI,eAAA;ACaJ;;ADXA;EACI,eAAA;ACcJ;;ADZA;EACI,gBAAA;ACeJ;;ADbA;EACI,gBAAA;ACgBJ;;ADdA;EACI,gBAAA;ACiBJ;;ADfA;EACI,4BAAA;ACkBJ;;ADhBA;EACI,kBAAA;ACmBJ;;ADjBA;EACI,8BAAA;ACoBJ;;ADlBA;EACI,gBAAA;ACqBJ;;ADnBA;EACI,gBAAA;ACsBJ;;ADpBA;EACI,gBAAA;ACuBJ;;ADrBA;EACI,gBAAA;ACwBJ;;ADtBA;EACI,gBAAA;ACyBJ;;ADvBA;EACI,gBAAA;AC0BJ;;ADxBA;EACI,mBAAA;AC2BJ;;ADzBA;EACI,aAAA;AC4BJ;;AD1BA;EACI,YAAA;AC6BJ;;AD3BA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AC8BJ;;AD5BA;EACI,WAAA;EACA,YAAA;AC+BJ;;AD7BA;EACI,WAAA;EACA,YAAA;ACgCJ;;AD9BA;EACI,WAAA;EACA,YAAA;ACiCJ;;AD/BA;EACI,WAAA;EACA,YAAA;ACkCJ;;ADhCA;EACI,WAAA;ACmCJ;;ADjCA;EACI,WAAA;ACoCJ;;ADlCA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;ACqCJ;;ADnCA;EACI,kBAAA;ACsCJ;;ADpCA;EACI,yBAAA;ACuCJ;;ADrCA;EACI,yBAAA;ACwCJ;;ADtCA;EACI,yBAAA;ACyCJ;;ADvCA;EACI,yBAAA;AC0CJ;;ADxCA;EACI,yBAAA;AC2CJ;;ADzCA;EACI,yBAAA;AC4CJ;;AD1CA;EACI,cA3RY;ACwUhB;;AD3CA;EACI,cArRW;ACmUf;;AD5CA;EACI,cA7RW;AC4Uf;;AD7CA;EACI,cA/RS;AC+Ub;;AD9CA;EACI,mBAhSY;ACiVhB;;AD/CA;EACI,mBApSW;ACsVf;;ADhDA;EACI,mBA7SY;ACgWhB;;ADjDA;EACI,mBAxSY;AC4VhB;;ADlDA;EACI,mBA1SW;AC+Vf;;ADnDA;EACI,oCAAA;ACsDJ;;ADpDA;EACI,QAAA;ACuDJ;;ADrDA;EACI,SAAA;ACwDJ;;ADtDA;EACI,UAAA;ACyDJ;;ADvDA;EACI,WAAA;AC0DJ;;ADxDA;EACI,WAAA;AC2DJ;;ADzDA;EACI,WAAA;EACA,YAAA;AC4DJ;;AD1DA;EACI,mBAAA;EACA,sBAAA;AC6DJ;;AD3DA;EACI,cAAA;AC8DJ;;AD5DA;EACI,iCAAA;AC+DJ;;AD1DY;EACI,4BAAA;EACA,+BAAA;AC6DhB;ADzDY;EACI,6BAAA;EACA,gCAAA;AC2DhB;;ADtDA;EACI,aAAA;EACA,gBAAA;ACyDJ;;ADvDA;EACI,aAAA;EACA,gBAAA;AC0DJ;;ADxDA;EACI,aAAA;EACA,gBAAA;AC2DJ;;ADzDA;EACI,8BAAA;AC4DJ;;AD1DA;EACI,yBAAA;EACA,qBAAA;AC6DJ;;AD3DA;EACI,gBAAA;AC8DJ;;AD5DA;EACI,sBAAA;AC+DJ;;AD7DA;EACI,WAAA;ACgEJ;;AD9DA;EACI,kCAAA;ACiEJ;ADhEI;EACI,sBAAA;ACkER;;AD9DI;EACI,cAAA;ACiER;;AD9DA;EACI,gBAAA;ACiEJ;ADhEI;EACI,eAAA;EACA,cAAA;ACkER;;AD/DA;EACI,WAAA;ACkEJ;;ADhEA;EACI,yBAvZY;EAwZZ,qBAxZY;AC2dhB;ADlEI;EACI,yBA1ZQ;EA2ZR,qBA3ZQ;EA4ZR,YAAA;ACoER;;ADjEA;EACI,cAhaY;EAiaZ,qBAjaY;ACqehB;ADnEI;EACI,yBAnaQ;EAoaR,qBApaQ;ACyehB;;ADlEA,qBAAA;AAEA,uBAAA;AACA;EACI,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;ACoEJ;;ADlEA,2BAAA;AAEA,qCAAA;AACA;EACI,mBAAA;EACA,gCAAA;EACA,oBAAA;ACoEJ;ADnEI;EACI,SAAA;EACA,eAAA;EACA,mBAAA;ACqER;ADnEI;EAII,UAAA;EACA,gBAAA;EACA,6BAAA;ACkER;ADvEQ;EACI,eAAA;ACyEZ;ADnEQ;EACI,cA3cU;EA4cV,qBAAA;ACqEZ;ADnEY;EACI,cA9cA;ACmhBhB;;AD/DI;EACI,qBAAA;ACkER;ADjEQ;EACI,8BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;ACmEZ;ADhEY;EACI,WAAA;EACA,cAAA;ACkEhB;;AD7DA;EACI,qDAAA;EACA,kBAAA;EACA,gCAAA;EAAA,eAAA;ACgEJ;AD9DI;EACI,aAAA;ACgER;AD9DI;EACI,6BAAA;EACA,UAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;ACgER;AD9DQ;EACI,WAAA;EACA,mBAvfI;EAwfJ,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;ACgEZ;AD9DQ;EACI,yBA/fI;EAggBJ,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EAEA,wEAAA;ACgEZ;AD7DI;EACI,eAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;AC+DR;AD7DI;EACI,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;EACA,6CAAA;EACA,gBAAA;AC+DR;AD7DQ;EACI,QAAA;EACA,YAAA;AC+DZ;AD5DI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AC8DR;;AD1DI;EACI,mBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA7iBQ;EA8iBR,YAAA;EACA,WAAA;EACA,gBAAA;AC6DR;AD5DQ;EACI,WAAA;EACA,YAAA;AC8DZ;AD5DQ;EACI,mBAtjBI;EAujBJ,WAAA;AC8DZ;AD5DQ;EACI,aAAA;AC8DZ;AD3DI;EACI,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,gBAAA;AC6DR;AD3DI;EACI,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AC6DR;AD3DI;EACI,cAAA;EACA,yBAAA;AC6DR;;ADxDI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;AC2DR;AD1DQ;EACI,YAAA;AC4DZ;;ADvDA;EAII,yBAAA;AC0DJ;ADzDI;EAKI,uCAAA;EACA,8CAAA;AC2DR;;ADvDA,eAAA;AACA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yEAAA;AC0DJ;ADzDI;EACI,SAAA;EACA,eAAA;AC2DR;AD1DQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AC4DZ;ADzDI;EACI,eAAA;EACA,cAAA;AC2DR;ADzDI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AC2DR;ADzDI;EACI,YAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AC2DR;ADzDI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;AC2DR;ADzDI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,gBAAA;AC2DR;ADzDI;EACI,YAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;AC2DR;;ADtDQ;EACI,cAzqBG;ACkuBf;ADtDI;EACI,mBA7qBO;ACquBf;ADtDI;EACI,mBAhrBO;ACwuBf;ADrDQ;EACI,oCAAA;ACuDZ;;ADjDQ;EACI,cA1rBI;AC8uBhB;ADjDI;EACI,mBA9rBQ;ACivBhB;ADjDI;EACI,mBAjsBQ;ACovBhB;ADhDQ;EACI,oCAAA;ACkDZ;;AD5CQ;EACI,cA3sBI;AC0vBhB;AD5CI;EACI,mBA/sBQ;AC6vBhB;AD5CI;EACI,mBAltBQ;ACgwBhB;AD3CQ;EACI,oCAAA;AC6CZ;;ADvCQ;EACI,cA5tBG;ACswBf;ADvCI;EACI,mBAhuBO;ACywBf;ADvCI;EACI,mBAnuBO;AC4wBf;ADtCQ;EACI,oCAAA;ACwCZ;;ADpCA,mBAAA;AAEA;EACI,qBAAA;EACA,UAAA;EACA,SAAA;ACsCJ;ADrCI;EACI,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;ACuCR;ADtCQ;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ACwCZ;ADtCQ;EACI,eAAA;EACA,cA5wBU;EA6wBV,gBAAA;EACA,cAAA;EACA,qBAAA;ACwCZ;ADtCY;EACI,cAjxBA;ACyzBhB;ADrCQ;EACI,eAAA;ACuCZ;ADrCQ;EACI,cAAA;ACuCZ;ADtCY;EACI,cAAA;EACA,iBAAA;ACwChB;ADrCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,cAnyBI;EAoyBJ,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;ACuCZ;ADtCY;EACI,mBA3yBA;EA4yBA,WAAA;ACwChB;;ADnCA;EACI,qBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;ACsCJ;ADrCI;EACI,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;ACuCR;ADtCQ;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ACwCZ;ADtCQ;EACI,eAAA;EACA,cAz0BU;EA00BV,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;ACwCZ;ADtCY;EACI,cA/0BA;ACu3BhB;ADrCQ;EACI,cAAA;ACuCZ;ADtCY;EACI,WAAA;EACA,YAAA;ACwChB;;ADnCA;EACI,aAAA;EACA,gBAAA;ACsCJ;;ADpCA;EACI,qBAAA;EACA,UAAA;EACA,SAAA;ACuCJ;ADtCI;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;ACwCR;ADvCQ;EACI,WAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;ACyCZ;ADvCQ;EACI,cAAA;EACA,qBAAA;ACyCZ;ADxCY;EACI,cAr3BA;AC+5BhB;;ADpCI;EACI,mBAAA;ACuCR;ADrCI;EACI,gBAAA;ACuCR;ADpCQ;EACI,gBAAA;EACA,cAAA;ACsCZ;ADnCI;EACI,eAAA;ACqCR;ADnCI;EACI,6BAAA;ACqCR;ADnCI;EACI,cAAA;ACqCR;ADnCI;EACI,gBAAA;EACA,gBAAA;ACqCR;ADnCI;EACI,cAAA;EACA,qBAAA;ACqCR;ADnCQ;EACI,cAz5BI;AC87BhB;ADlCI;EACI,mBAAA;ACoCR;;ADjCA;EACI,oBAAA;ACoCJ;;AD/BY;EACI,sBAAA;ACkChB;ADhCY;EACI,yBAAA;ACkChB;;AD1BY;EACI,yBAAA;AC6BhB;;ADvBI;EACI,mBAAA;AC0BR;ADxBI;EACI,WAAA;AC0BR;;ADvBA,yCAAA;AAEA,wBAAA;AAEI;EACI,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACwBR;ADvBQ;EACI,UAAA;EACA,SAAA;ACyBZ;ADvBQ;EACI,SAAA;EACA,WAAA;ACyBZ;;ADrBA;EACI,cAv9BY;AC++BhB;ADvBI;EACI,WAAA;ACyBR;;ADtBA;EACI,yBA79BY;EA89BZ,qBA99BY;ACu/BhB;;ADvBA,4BAAA;AAEA,6BAAA;AAEI;EACI,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;ACwBR;ADrBQ;EACI,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;ACuBZ;ADtBY;EACI,yBAAA;EACA,0BAAA;ACwBhB;ADtBY;EACI,gBAAA;EACA,cAz/BA;EA0/BA,qBAAA;ACwBhB;ADtBgB;EACI,0BAAA;ACwBpB;ADrBY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;ACuBhB;ADrBY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;ACuBhB;ADrBY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;ACuBhB;ADrBY;EACI,qBAAA;EACA,SAAA;EACA,UAAA;ACuBhB;ADtBgB;EACI,qBAAA;EACA,iBAAA;EACA,eAAA;ACwBpB;ADrBY;EACI,iBAAA;ACuBhB;ADrBY;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;ACuBhB;;ADlBA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;ACqBJ;;ADnBA;EACI,mBAAA;ACsBJ;;ADpBA;EACI,mBAAA;ACuBJ;;ADrBA;EACI,mBAAA;ACwBJ;;ADtBA,iCAAA;AAGI;EACI,qBAAA;ACuBR;;ADnBA,oBAAA;AAEI;EACI,qBAAA;EACA,UAAA;EACA,SAAA;ACqBR;ADpBQ;EACI,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;ACsBZ;ADpBY;EACI,eAAA;ACsBhB;ADpBY;EACI,6BAAA;EACA,gBAAA;ACsBhB;ADnBQ;EACI,6BAAA;EACA,cA9kCG;EA+kCH,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;ACqBZ;ADlBI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;ACoBR;ADnBQ;EACI,qBAtmCG;EAumCH,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;ACqBZ;ADnBQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;ACqBZ;;ADjBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;ACoBJ;ADnBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;ACqBR;ADnBI;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;ACqBR;;ADlBA;EACI,mBA7oCY;ACkqChB;;ADnBA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;ACsBJ;;ADpBA;EACI,cAAA;ACuBJ;;ADrBA;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EAEA,wBAAA;ACwBJ;;ADtBA,wBAAA;AAEA,sBAAA;AACA;EACI,aAAA;EACA,eAAA;ACwBJ;;ADtBA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yEAAA;EACA,kBAAA;EACA,mBAAA;ACyBJ;ADxBI;EACI,WAAA;EACA,kBAAA;EACA,mBAlrCO;EAmrCP,YAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,MAAA;AC0BR;;ADvBA;EACI,4BAAA;AC0BJ;ADzBI;EACI,kBAAA;EACA,eAAA;EACA,cAlsCQ;EAmsCR,cAAA;AC2BR;ADxBQ;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AC0BZ;ADxBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AC0BhB;ADxBY;EACI,kBAAA;AC0BhB;ADvBQ;EACI,mBAAA;EACA,WAAA;EACA,yBAAA;ACyBZ;ADxBY;EACI,gBAAA;AC0BhB;ADvBQ;EACI,sBAAA;EACA,gBAAA;EACA,WAAA;ACyBZ;ADxBY;EACI,gBAAA;AC0BhB;ADvBQ;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;ACyBZ;ADxBY;EACI,gBAAA;AC0BhB;ADvBQ;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;ACyBZ;ADxBY;EACI,gBAAA;AC0BhB;;ADrBA;EACI,4BAAA;ACwBJ;ADvBI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;ACyBR;ADxBQ;EACI,WAAA;EACA,mBAtwCI;EAuwCJ,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AC0BZ;ADvBI;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;ACyBR;ADvBI;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ACyBR;ADvBI;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAjyCc;AC0zCtB;ADxBQ;EACI,cAlyCI;EAmyCJ,0BAAA;AC0BZ;;ADtBA;EACI,yDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;ACyBJ;;ADvBA,0BAAA;AAEA,qBAAA;AACA;EACI,kBAAA;ACyBJ;ADxBI;EACI,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AC0BR;;ADtBI;EACI,gBAAA;EACA,qBA9zCO;EA+zCP,gBAAA;EACA,aAAA;EACA,iBAAA;ACyBR;ADvBI;EACI,kBAAA;ACyBR;ADxBQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AC0BZ;;ADtBA,yBAAA;AAEA,cAAA;AACA;EACI,WAAA;EACA,aAAA;ACwBJ;;ADtBA,kBAAA;AAEA,mBAAA;AACA;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;ACwBJ;ADrBQ;EACI,gBAAA;EACA,eAAA;ACuBZ;ADpBI;EACI,eAAA;ACsBR;ADpBI;EACI,eAAA;EACA,iCAAA;EACA,iBAAA;ACsBR;;ADnBA,uBAAA;AAEA,eAAA;AACA;EACI,6BAAA;EACA,gBAAA;ACqBJ;;ADnBA;EACI,gBAAA;ACsBJ;;ADpBA,mBAAA;AAEA,gBAAA;AAEI;EACI,gBAAA;ACqBR;ADpBQ;EACI,kBAAA;ACsBZ;ADrBY;EACI,eAAA;EACA,cAAA;ACuBhB;ADpBQ;EACI,aAAA;ACsBZ;ADpBQ;EACI,kBAAA;ACsBZ;ADnBI;EACI,iBAAA;ACqBR;;ADlBA;EACI,UAAA;EACA,0BAAA;ACqBJ;;ADnBA,oBAAA;AAEA,cAAA;AAEI;EACI,mBAAA;ACoBR;ADnBQ;EACI,SAAA;ACqBZ;;ADhBI;EACI,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;ACmBR;ADhBQ;EACI,yBAAA;EACA,0BAAA;EACA,cAAA;ACkBZ;;ADbI;EACI,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;ACgBR;ADbQ;EACI,yBAAA;EACA,0BAAA;EACA,cAAA;ACeZ;ADbQ;EACI,WAAA;EACA,yBA37CI;EA47CJ,qBA57CI;AC28ChB;;ADVI;EACI,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;ACaR;ADVQ;EACI,yBAAA;EACA,0BAAA;EACA,cAAA;EACA,iCAAA;ACYZ;ADXY;EACI,6BAAA;EACA,yBAAA;ACahB;ADVQ;EACI,6BAAA;ACYZ;;ADPI;EACI,gCAAA;ACUR;ADPQ;EACI,gBAAA;EACA,cAAA;ACSZ;ADRY;EACI,cAh+CA;AC0+ChB;ADPQ;EACI,WAAA;EACA,yBAp+CK;AC6+CjB;ADNI;EACI,gBAAA;ACQR;;ADHQ;EACI,gBAAA;EACA,cAAA;ACMZ;ADLY;EACI,cAl/CA;ACy/ChB;ADJQ;EACI,WAAA;EACA,yBAv/CI;AC6/ChB;;ADFA,kBAAA;AAEA,gBAAA;AAEI;EACI,gBAAA;ACGR;ADFQ;EACI,kBAAA;EACA,cAAA;ACIZ;ADHY;EACI,cArgDA;EAsgDA,sBAAA;ACKhB;ADFQ;EACI,cA1gDI;EA2gDJ,sBAAA;ACIZ;;ADAA;EACI,gBAAA;ACGJ;;ADDA;EACI,iBAAA;ACIJ;;ADFA;EACI,4BAAA;EACA,aAAA;EACA,gBAAA;ACKJ;ADFQ;EACI,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ACIZ;ADFY;EACI,yBAAA;ACIhB;ADFgB;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAziDJ;EA0iDI,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,SAAA;ACIpB;ADDY;EACI,kBAAA;ACGhB;ADDY;EACI,kBAAA;ACGhB;ADDgB;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ACGpB;ADDgB;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;ACGpB;ADDgB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;ACGpB;ADCQ;EACI,yBAAA;ACCZ;ADAY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAnlDA;EAolDA,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,SAAA;ACEhB;;ADGA;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ACAJ;ADEI;EACI,cAAA;EACA,eAAA;ACAR;ADEI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;ACAR;ADCQ;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;ACCZ;;ADGA,oBAAA;AAEA,sBAAA;AAEI;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;ACFR;ADGQ;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;ACDZ;ADGQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,mBAAA;ACDZ;ADGQ;EACI,SAAA;EACA,eAAA;ACDZ;ADEY;EACI,cAAA;EACA,qBAAA;ACAhB;ADEgB;EACI,cAlqDJ;ACkqDhB;ADIQ;EACI,eAAA;EACA,cAAA;EACA,eAAA;ACFZ;ADIQ;EACI,kBAAA;EACA,QAAA;EACA,MAAA;ACFZ;ADGY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACDhB;;ADMA,0BAAA;AAEA,sBAAA;AACA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;ACJJ;ADMI;EACI,gBAAA;ACJR;ADOI;EACI,qBAAA;ACLR;ADQI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;ACNR;ADQQ;EACI,WAAA;EACA,YAAA;ACNZ;ADUI;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;ACRR;;ADWA,0BAAA;AAEA,mBAAA;AACA;EACI,aAAA;EACA,6BAAA;ACTJ;ADUI;EACI,YAAA;ACRR;;ADWA;EACI,6BAAA;EACA,cAAA;EACA,kBAAA;ACRJ;;ADUA;EACI,0BAAA;ACPJ;;ADSA;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;ACNJ;ADOI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;ACLR;ADOI;EACI,mBAAA;EACA,kBAAA;EACA,uBAAA;ACLR;ADMQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,6CAAA;EAEA,0BAAA;ACJZ;ADMQ;EACI,eAAA;ACJZ;ADMQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ACJZ;;ADQA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;ACLJ;ADMI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;ACJR;ADMI;EACI,mBAAA;EACA,kBAAA;EACA,uBAAA;ACJR;ADKQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,6CAAA;EAEA,wBAAA;ACHZ;ADKQ;EACI,eAAA;ACHZ;ADKQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ACHZ;;ADOA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;ACJJ;;ADMA,uBAAA;AAEA,qBAAA;AACA;EACI,kBAAA;ACJJ;ADKI;EACI,SAAA;EACA,eAAA;ACHR;;ADMA;EACI,kBAAA;ACHJ;ADII;EACI,gBAAA;EACA,eAAA;ACFR;ADII;EACI,SAAA;EACA,cAAA;ACFR;;ADKA,yBAAA;AAEA,uBAAA;AACA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yEAAA;EACA,kBAAA;ACHJ;ADII;EACI,SAAA;EACA,eAAA;ACFR;ADII;EACI,kBAAA;EACA,cAAA;ACFR;ADGQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;ACDZ;;ADKA,2BAAA;AAEA,uBAAA;AACA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,qDAAA;EACA,kBAAA;ACHJ;ADII;EACI,SAAA;EACA,eAAA;ACFR;ADII;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFR;ADKQ;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;ACHZ;ADIY;EACI,WAAA;ACFhB;ADIY;EACI,cA74DA;AC24DhB;;ADQI;EACI,qBAAA;EACA,UAAA;EACA,SAAA;ACLR;ADMQ;EACI,iBAAA;EACA,kBAAA;EACA,cAz5DK;EA05DL,kBAAA;EACA,mBAAA;ACJZ;ADMY;EACI,gBAAA;ACJhB;ADOY;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;ACLhB;;ADUA;EACI,sBAAA;EACA,qDAAA;EACA,kBAAA;ACPJ;;ADSA;EACI,aAAA;EACA,6BAAA;ACNJ;ADQQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;ACNZ;ADOY;EACI,cAAA;EACA,qBAAA;ACLhB;ADOgB;EACI,cA/7DJ;AC07DhB;ADSQ;EACI,gBAAA;ACPZ;ADWQ;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,qBAAA;ACTZ;ADWY;EACI,cAh9DA;ACu8DhB;ADWY;EACI,kBAAA;EACA,gBAAA;ACThB;ADWY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ACThB;;ADeI;EACI,aAAA;EACA,kBAAA;ACZR;ADcI;EACI,6BAAA;EACA,mBAAA;EACA,oBAAA;ACZR;ADcQ;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;ACZZ;ADcQ;EACI,eAAA;EACA,eAAA;ACZZ;ADcY;EACI,cAAA;EACA,qBAAA;ACZhB;ADcgB;EACI,cAv/DJ;AC2+DhB;ADgBQ;EACI,eAAA;EACA,iBAAA;ACdZ;;ADkBA,uBAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qDAAA;EACA,gBAAA;EACA,YAAA;ACfJ;;ADiBA,eAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qDAAA;ACdJ;ADeI;EACI,yBAAA;EACA,aAAA;EACA,YAAA;ACbR;ADeI;EACI,eAAA;ACbR;ADgBQ;EACI,qBAAA;EACA,aAAA;EACA,cAAA;ACdZ;ADeY;EACI,cA9hEA;ACihEhB;ADeY;EACI,WAAA;EACA,YAAA;ACbhB;ADiBI;EACI,qBAAA;EACA,UAAA;EACA,SAAA;EACA,0BAAA;ACfR;ADgBQ;EACI,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ACdZ;ADgBY;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ACdhB;ADiBQ;EACI,2BAAA;EACA,4BAAA;ACfZ;;ADmBA;EAEI,0FAAA;AChBJ;;ADkBA;EAEI,mGAAA;ACfJ;;ADiBA;EAEI,0FAAA;ACdJ;;ADgBA,mBAAA;AAEA,mBAAA;AACA;EACI,kBAAA;EACA,mBAAA;ACdJ;ADeI;EACI,WAAA;EACA,cAAA;ACbR;ADeI;EACI,WAAA;ACbR;ADeI;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;ACbR;ADeI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;ACbR;ADcQ;EACI,YAAA;EACA,cAAA;ACZZ;ADcQ;EACI,WAAA;ACZZ;ADcQ;EACI,YAAA;EACA,cAAA;ACZZ;ADcQ;EACI,WAAA;ACZZ;ADeI;EACI,gBAAA;ACbR;ADeI;EACI,WAAA;ACbR;ADcQ;EACI,cAAA;EACA,mBAAA;ACZZ;ADaY;EACI,UAAA;EACA,aAAA;EACA,gBAAA;ACXhB;ADaY;EACI,YAAA;ACXhB;ADaY;EACI,cAAA;EACA,kBAAA;ACXhB;ADYgB;EACI,UAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EAKA,yBAAA;ACVpB;ADgBQ;EACI,kBAAA;EACA,kBAAA;ACdZ;ADeY;EACI,YAAA;EACA,cAAA;ACbhB;ADeY;EACI,WAAA;ACbhB;ADeY;EACI,YAAA;EACA,cAAA;ACbhB;ADeY;EACI,WAAA;ACbhB;ADeY;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;ACbhB;ADcgB;EACI,cAAA;ACZpB;ADcgB;EACI,eAAA;EACA,gBAAA;ACZpB;ADcgB;EACI,eAAA;EACA,cAAA;ACZpB;ADeY;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;ACbhB;ADeY;EACI,kBAAA;EACA,gBAAA;EACA,yEAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;ACbhB;ADcgB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,sDAAA;EACA,OAAA;EACA,SAAA;EACA,iBAAA;ACZpB;ADcgB;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;ACZpB;ADcgB;EACI,eAAA;EACA,gBAAA;ACZpB;;ADkBA;EACI,oCAAA;EACA,WAAA;ACfJ;ADgBI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACdR;;ADiBA;EACI,yBAvvEY;EAwvEZ,WAAA;ACdJ;ADeI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACbR;;ADgBA;EACI,yBAAA;EACA,WAAA;ACbJ;ADcI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACZR;;ADeA;EACI,yBAnwEY;EAowEZ,WAAA;ACZJ;ADaI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACXR;;ADcA;EACI,yBAAA;EACA,WAAA;ACXJ;ADYI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACVR;;ADaA;EACI,yBAAA;EACA,WAAA;ACVJ;ADWI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACTR;;ADYA;EACI,yBAhyEW;EAiyEX,WAAA;ACTJ;ADUI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACRR;;ADWA,uBAAA;AAEA,qBAAA;AACA;EACI,gBAAA;EACA,aAAA;ACTJ;ADWI;EACI,kBAAA;EACA,6BAAA;EACA,oBAAA;ACTR;ADWQ;EACI,SAAA;EACA,eAAA;EACA,yBAAA;ACTZ;ADWQ;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;ACTZ;;ADaA,yBAAA;AAEA,sBAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;ACXJ;ADYI;EACI,WAAA;EACA,YAAA;EACA,cAt1ES;AC40EjB;ADYI;EACI,gBAAA;EACA,mBAAA;ACVR;ADYI;EACI,SAAA;ACVR;ADYI;EACI,YAAA;EACA,gBAAA;ACVR;ADYI;EACI,yBAr2EQ;EAs2ER,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;ACVR;ADYQ;EACI,sBAAA;EACA,kBAAA;ACVZ;;ADcA,0BAAA;AAEA,cAAA;AACA;EACI,aAAA;ACZJ;;ADcA;EACI,aAAA;ACXJ;;ADaA,kBAAA;AAEA,uBAAA;AACA;EACI,WAAA;ACXJ;ADYI;EACI,iBAAA;ACVR;ADWQ;EACI,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;ACTZ;ADWQ;EACI,WAAA;EACA,mBA/4EI;EAg5EJ,yBAAA;EACA,gCAAA;ACTZ;;ADaA,2BAAA;AAEA,qBAAA;AAEI;EACI,mBAAA;EACA,eAAA;ACZR;ADcI;EACI,0BAAA;ACZR;ADcI;EACI,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EAIA,eAAA;ACfR;ADYQ;EACI,UAAA;ACVZ;ADcQ;EACI,cA36EI;AC+5EhB;ADcQ;EACI,YAAA;EACA,eAAA;ACZZ;ADeI;EACI,sBAAA;EACA,0BAAA;ACbR;ADcQ;EACI,mBAAA;ACZZ;ADaY;EACI,gBAAA;ACXhB;;ADgBA,yBAAA;AAEA,uBAAA;AACA;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ACdJ;ADgBI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;ACdR;;ADiBA,2BAAA;AAEA,kBAAA;AACA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ACfJ;ADgBI;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;ACdR;ADeQ;EACI,aAAA;ACbZ;ADeQ;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;ACbZ;ADcY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,wBAAA;ACZhB;ADeQ;EACI,sBAAA;ACbZ;ADcY;EACI,yBAv/EA;AC2+EhB;ADeQ;EAGI,2BAAA;ACbZ;ADeQ;EACI,mBAAA;EACA,wBAAA;ACbZ;ADeQ;EACI,kBAAA;ACbZ;;ADiBA,sBAAA;AAEA,wBAAA;AACA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;ACfJ;ADgBI;EACI,cAAA;EACA,iBAAA;ACdR;ADgBI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;ACdR;ADeQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ACbZ;ADgBI;EACI,oBAAA;EACA,kBAAA;ACdR;ADgBI;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ACdR;ADiBQ;EACI,UAAA;EACA,cAAA;EACA,qBAAA;ACfZ;ADgBY;EACI,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;ACdhB;ADkBI;EACI,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;AChBR;;ADmBA,4BAAA;AAEA,iBAAA;AACA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mDAAA;EACA,4BAAA;ACjBJ;ADkBI;EACI,SAAA;EACA,cAAA;AChBR;ADiBQ;EACI,cAzlFI;AC0kFhB;ADgBY;EACI,0BAAA;ACdhB;;ADmBA,qBAAA","sourcesContent":["/*\nTable Of Content\n=================================\n* Color system\n* Body\n* Typography\n* Todos\n* Calendar\n* Notes\n* Search\n* Notifications\n* Breadcrumbs\n* Alerts\n* Badges\n* Buttons\n* Cards\n* Dropdowns\n* Forms\n* List Groups\n* Modals\n* Progress bars\n* Tables\n* Tabs\n* Signup\n* Login\n* Forgot Password\n*/\n\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i');\n\n@import url(../css/LineIcons.min.css);\n\n// JvectorMap CSS\n@import url('https://cdnjs.cloudflare.com/ajax/libs/jvectormap/2.0.4/jquery-jvectormap.css');\n\n/* Default color & font Variables */\n$body-font-family: 'Roboto', sans-serif;\n$body-bg-color: #f3f6f9;\n$template-text-color: #47404f;\n$primary-color: #2962ff;\n$pragraph-color: #797979;\n$border-color: #ebebee;\n$danger-color: #ff3547;\n$global-color: #47404f;\n$gray-color: #a1aab2;\n$purple-color: #7266ba;\n$light-blue-bg: #42a5f6;\n$success-color: #7ed320;\n$danger-color: #f75d81;\n/* End default color & font Variables */\n\n/* Default style */\nbody {\n    background-color: $body-bg-color;\n    color: $template-text-color;\n    font-size: 14px;\n    font-family: $body-font-family;\n}\na {\n    transition: .4s;\n    -webkit-transition: .4s;\n    &:hover {\n        text-decoration: none;\n        color: $primary-color;\n    }\n}\np {\n    color: $pragraph-color;\n    line-height: 24px;\n}\nimg {\n    max-width: 100%;\n}\n.input-group-text {\n    padding: 3px 13px;\n}\niframe {\n    border: 0;\n}\n.form-select {\n    font-size: 13px;\n}\n\n/* Scrollbar style */\n::-webkit-scrollbar {\n    width: 4px;\n    height: 6px;\n}\n::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px $border-color; \n    border-radius: 30px;\n}\n::-webkit-scrollbar-thumb { \n    border-radius: 30px;\n    background: $primary-color; \n    box-shadow: inset 0 0 6px $border-color; \n}\n::-webkit-scrollbar-thumb:window-inactive {\n\tbackground: $primary-color;\n}\n/* End Scrollbar style */\nbutton:focus {\n    outline: 0;\n}\n.btn {\n    font-size: 13px;\n    padding: 10px 15px;\n    line-height: 1;\n    border-radius: 4px;\n}\n.badge {\n    padding-right: 10px;\n    padding-left: 10px;\n    font-size: 10px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n.btn-outline-light {\n    color: #848484;\n}\n.btn-lg, .btn-group-lg > .btn {\n    padding: 10px 25px;\n    font-size: 16px;\n    line-height: 1.5;\n}\n.btn-md {\n    padding: 10px 20px;\n    font-size: 15px;\n}\n.btn-xs {\n    padding: 8px 16px;\n    font-size: 13px;\n}\n.radius-0 {\n    border-radius: 0 !important;\n}\n.dropdown-item {\n    font-size: 14px;\n}\n.btn-warning {\n    color: #fff;\n    &:hover {\n        color: #fff;\n    }\n}\n.btn-outline-warning {\n    &:hover {\n        color: #fff;\n    }\n}\n.form-control {\n    border-radius: 4px;\n    border-color: #ebebee;\n    font-size: 13px;\n    box-shadow: none;\n    &:focus {\n        box-shadow: none;\n        border-color: $primary-color;\n    }\n}\n.form-group {\n    .form-text {\n        margin-top: 10px;\n        font-size: 12px;\n    }\n    > label {\n        text-transform: capitalize;\n        font-weight: 500;\n    }\n}\n.form-check-input {\n    margin-top: 2px;\n}\n.custom-control-label {\n    padding-top: 4px;\n}\n.input-group-text {\n    color: #fff;\n    background-color: $primary-color;\n    border-radius: 0;\n} \n.loader {\n    top: 20px;\n    position: absolute;\n    left: 60%;\n    text-align: center;\n}\n/* End Default style */\n \n/* Helper class */\n.fs-10 {\n    font-size: 10px;\n}\n.fs-11 {\n    font-size: 11px;\n}\n.fs-12 {\n    font-size: 12px;\n}\n.fs-13 {\n    font-size: 13px;\n}\n.fs-14 {\n    font-size: 14px;\n}\n.fs-15 {\n    font-size: 15px;\n}\n.fs-18 {\n    font-size: 18px;\n}\n.fs-20 {\n    font-size: 20px;\n}\n.fs-22 {\n    font-size: 22px; \n}\n.fs-40 {\n    font-size: 40px;\n}\n.fs-50 {\n    font-size: 50px;\n}\n.fw-400 {\n    font-weight: 400;\n}\n.fw-500 {\n    font-weight: 500;\n}\n.fw-600 {\n    font-weight: 600;\n}\n.mr-5 {\n    margin-right: 5px !important;\n}\n.mr-10 {\n    margin-right: 10px;\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.mt-40 {\n    margin-top: 40px;\n}\n.mt-minus-1 {\n    margin-top: -1px;\n}\n.mt-minus-2 {\n    margin-top: -2px;\n}\n.mt-minus-3 {\n    margin-top: -3px;\n}\n.mt-minus-4 {\n    margin-top: -4px;\n}\n.mt-minus-5 {\n    margin-top: -5px;\n}\n.pr-70 {\n    padding-right: 70px;\n}\n.p-30 {\n    padding: 30px;\n}\n.fr {\n    float: right;\n}\n.wh-13 {\n    width: 13px;\n    height: 13px;\n    margin-top: -2px;\n}\n.wh-15 {\n    width: 15px;\n    height: 15px;\n}\n.wh-30 {\n    width: 30px;\n    height: 30px;\n}\n.wh-35 {\n    width: 35px;\n    height: 35px;\n}\n.wh-40 {\n    width: 40px;\n    height: 40px;\n}\n.w-80 {\n    width: 80px;\n}\n.w-full {\n    width: 100%;\n}\n.mw-350 {\n    max-width: 350px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.relative {\n    position: relative;\n}\n.border {\n    border: 1px solid $border-color;\n}\n.black-text {\n    color: $template-text-color !important;\n}\n.primary-text {\n    color: $primary-color !important;\n}\n.purple-text {\n    color: $purple-color !important;\n}\n.success-text {\n    color: $success-color !important;\n}\n.danger-text {\n    color: $danger-color !important;\n}\n.theme-color {\n    color: $primary-color;\n}\n.danger-color {\n    color: $danger-color;\n}\n.global-color {\n    color: $global-color;\n}\n.gray-color {\n    color: $gray-color;\n}\n.light-blue-bg {\n    background: $light-blue-bg;\n}\n.purple-bg {\n    background: $purple-color;\n}\n.primary-bg {\n    background: $primary-color;\n}\n.success-bg {\n    background: $success-color;\n}\n.danger-bg {\n    background: $danger-color;\n}\n.theme-bg {\n    background-color: $primary-color !important;\n}\n.right {\n    right: 0;\n} \n.bottom {\n    bottom: 0;\n}\n.right-3 {\n    right: 3px;\n} \n.bottom-2 {\n    bottom: 2px;\n}\n.bottom-3 {\n    bottom: 3px;\n}\n.d-table {\n    width: 100%;\n    height: 100%;\n}\n.d-tablecell {\n    display: table-cell;\n    vertical-align: middle;\n}\n.line-height-1 {\n    line-height: 1;\n}\n.bg-white {\n    background-color: #fff !important;\n}\n.border-radius-fl-item {\n    .page-item {\n        &:first-child {\n            .page-link {\n                border-top-left-radius: 15px;\n                border-bottom-left-radius: 15px;\n            }\n        }\n        &:last-child {\n            .page-link {\n                border-top-right-radius: 15px;\n                border-bottom-right-radius: 15px;\n            }\n        }\n    }\n}\n.height-408 {\n    height: 408px;\n    overflow-y: auto;\n}\n.height-310 {\n    height: 310px;\n    overflow-y: auto;\n}\n.height-500 {\n    height: 500px;\n    overflow-y: auto;\n}\n.rounded {\n    border-radius: 50px !important;\n}\n.alert-light {\n    background-color: #f9f9f9;\n    border-color: #f9f9f9;\n}\n.alert:last-child {\n    margin-bottom: 0;\n}\n.alert-dismissible .close {\n    padding: 0.60rem 1.20rem; \n}\n.white-color {\n    color: #fff;\n}\n.card-img-overlay {\n    background: rgba(41, 98, 255, .5);\n    .card-title  {\n        color: #fff !important;\n    }\n}\n.alert-success {\n    p {\n        color: #155724;\n    }\n}\n.dropdown-menu {\n    border-radius: 0;\n    .dropdown-item {\n        font-size: 13px;\n        color: #797979;\n    }\n}\n.badge-warning {\n    color: #fff;\n}\n.btn-primary {\n    background-color: $primary-color;\n    border-color: $primary-color;\n    &:hover {\n        background-color: $primary-color;\n        border-color: $primary-color;\n        opacity: .7;\n    }\n}\n.btn-outline-primary {\n    color: $primary-color;\n    border-color: $primary-color;\n    &:hover {\n        background-color: $primary-color;\n        border-color: $primary-color;\n    }\n}\n/* End helper class */\n\n/* Main content style */\n.main-content {\n    width: 100%;\n    margin-top: 62px;\n    transition: all .50s ease-in-out;\n    -webkit-transition: all .50s ease-in-out;\n    padding: 30px 30px 0;\n    position: relative;\n    min-height: calc(100vh - 62px);\n    padding-left: 250px;\n    overflow: hidden;\n}\n/* End main content style */\n\n/* Dashboard landing page v.1 style */\n.main-content-header {\n    margin-bottom: 20px;\n    border-bottom: 1px solid $border-color;\n    padding-bottom: 10px;\n    h1 {\n        margin: 0;\n        font-size: 18px;\n        padding-right: 15px;\n    }\n    .breadcrumb {\n        .breadcrumb-item {\n            margin-top: 1px;\n        }\n        padding: 0;\n        margin-bottom: 0;\n        background-color: transparent;\n\n        a {\n            color: $template-text-color;\n            text-decoration: none;\n\n            &:hover {\n                color: $primary-color;\n            }\n        }\n    }\n}\n.single-sales-card {\n    .card-body {\n        padding: 0 !important;\n        .icon {\n            background: rgba(0,0,0,0.1);\n            color: #fff;\n            width: 80px;\n            height: 80px;\n            padding: 22px;\n            border-radius: 4px 0 0 4px; \n        }\n        .content {\n            p {\n                color: #fff;\n                line-height: 1;\n            }\n        }\n    }\n}\n.card {\n    box-shadow: 2px 3px 10px 0px rgba(119,119,119,0.1);\n    border-radius: 4px;\n    border: initial;\n\n    .card-body {\n        padding: 20px;\n    }\n    .card-header {\n        background-color: transparent;\n        padding: 0;\n        border-bottom: 1px solid $border-color;\n        position: relative;\n        margin-bottom: 20px;\n\n        &::before {\n            content: '';\n            background: $primary-color;\n            height: 1px;\n            width: 30px;\n            position: absolute;\n            left: 0;\n            bottom: -1px;\n        }\n        .day {\n            background-color: $primary-color;\n            position: absolute;\n            bottom: 2px;\n            right: 0;\n            color: #fff;\n            display: inline-block;\n            font-size: 10px;\n            padding: 5px 10px 5px 22px;\n            -webkit-clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 16% 50%, 0% 0%);\n            clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 16% 50%, 0% 0%);\n        }\n    }\n    .card-title {\n        font-size: 15px;\n        padding-bottom: 10px;\n        padding: 0;\n        color: #323332;\n    }\n    .header {\n        padding: 0.75rem 1.25rem;\n        margin-bottom: 0;\n        color: inherit;\n        background-color: rgba(0, 0, 0, 0.03);\n        border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n        font-weight: 600;\n        \n        &::before {\n            right: 0;\n            margin: auto;\n        }\n    }\n    .content {\n        margin: auto;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        max-width: 120px;\n    }\n}\n.card-dropdown {\n    .btn {\n        border-radius: 30px;\n        font-size: 15px;\n        padding: 0;\n        line-height: 25px;\n        background: #fff;\n        color: $primary-color;\n        height: 25px;\n        width: 25px;\n        margin-top: -5px;\n        .icon {\n            width: 18px;\n            height: 18px;\n        }\n        &:hover {\n            background: $primary-color;\n            color: #fff;\n        }\n        &:after {\n            display: none;\n        }\n    }\n    .dropdown-menu.show {\n        left: auto !important;\n        right: 0 !important;\n        transform: inherit !important;\n        top: 24px !important;\n        border-radius: 0;\n    }\n    .dropdown-item {\n        font-size: 13px;\n        padding: 0.40rem 1rem;\n        white-space: pre-wrap;\n        font-weight: 300;\n    }\n    .dropdown-item.active, .dropdown-item:active {\n        color: #16181b;\n        background-color: #f8f9fa;\n    }\n}\n\n.card-header {\n    .select-month-form {\n        position: absolute;\n        right: 0;\n        bottom: -1px;\n        .form-control {\n            height: 30px;\n        }\n    }\n}\n\n.hover-card {\n    -webkit-transition: all .30s ease;\n    -o-transition: all .30s ease;\n    -moz-transition: all .30s ease;\n    transition: all .30s ease;\n    &:hover {\n        -webkit-transform: translateY(-4px) scale(1.01);\n        -moz-transform: translateY(-4px) scale(1.01);\n        -ms-transform: translateY(-4px) scale(1.01);\n        -o-transform: translateY(-4px) scale(1.01);\n        transform: translateY(-4px) scale(1.01);\n        box-shadow: 0 15px 25px rgba(60, 50, 100, .1);\n    }\n}\n\n/* stats card */\n.stats-card {\n    background-color: #fff;\n    padding: 20px;\n    position: relative;\n    border-radius: 4px;\n    box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n    h3 {\n        margin: 0;\n        font-size: 22px;\n        .icon {\n            margin-left: 5px;\n            width: 18px;\n            height: 18px;\n            margin-top: -4px;\n        }\n    }\n    p {\n        margin: 5px 0 0;\n        line-height: 1\n    }\n    i {\n        position: absolute;\n        right: 0;\n        top: 0;\n        color: #fff;\n        height: 50px;\n        width: 50px;\n        border-radius: 30px 0 30px 30px;\n        transition: .5s;\n        text-align: center;\n        line-height: 50px;\n        font-size: 25px;\n    }\n    &:hover i {\n        height: 100%;\n        border-radius: 0 4px 4px 0;\n        width: 70px;\n        line-height: 85px;\n        font-size: 35px;\n    }\n    &:hover .icon-hover {\n        height: 60px;\n        width: 60px;\n        line-height: 60px;\n        border-radius: 30px 0 30px 30px;\n        font-size: 30px;\n    }\n    .stats-icon {\n        position: absolute;\n        right: 0;\n        top: 0;\n        color: #fff;\n        height: 50px;\n        width: 50px;\n        padding: 10px;\n        border-radius: 30px 0 30px 30px;\n        transition: .5s;\n    }\n    &:hover .stats-icon {\n        height: 100%;\n        border-radius: 0 4px 4px 0;\n        width: 70px;\n        padding: 15px;\n    }\n}\n.purple-card {\n    h3 {\n        .icon {\n            color: $purple-color;\n        }\n    }\n    .stats-icon {\n        background: $purple-color;\n    }  \n    i {\n        background: $purple-color;\n    }\n    .progress {\n        .progress-bar {\n            background-color: $purple-color !important;\n        }\n    }\n}\n.light-blue-card {\n    h3 {\n        .icon {\n            color: $light-blue-bg;\n        }\n    }\n    .stats-icon {\n        background: $light-blue-bg;\n    }  \n    i {\n        background: $light-blue-bg;\n    }\n    .progress {\n        .progress-bar {\n            background-color: $light-blue-bg !important;\n        }\n    }\n}\n.success-card {\n    h3 {\n        .icon {\n            color: $success-color;\n        }\n    }\n    .stats-icon {\n        background: $success-color;\n    }  \n    i {\n        background: $success-color;\n    }\n    .progress {\n        .progress-bar {\n            background-color: $success-color !important;\n        }\n    }\n}\n.danger-card {\n    h3 {\n        .icon {\n            color: $danger-color;\n        }\n    }\n    .stats-icon {\n        background: $danger-color;\n    }  \n    i {\n        background: $danger-color;\n    }\n    .progress {\n        .progress-bar {\n            background-color: $danger-color !important;\n        }\n    }\n}\n/* End stats card */\n\n.top-rated-products {\n    list-style-type: none; \n    padding: 0;\n    margin: 0;\n    .single-product {\n        border-bottom: 1px solid $border-color;\n        position: relative;\n        padding-left: 80px;\n        padding-top: 15px;\n        padding-bottom: 15px;\n        padding-right: 45px;\n        img {\n            border: 1px solid #f3f3f3;\n            width: 65px;\n            height: 65px;\n            position: absolute;\n            left: 0;\n            top: 14px;\n        }\n        .product-title {\n            font-size: 13px;\n            color: $template-text-color;\n            font-weight: 500;\n            line-height: 1;\n            text-decoration: none;\n\n            &:hover {\n                color: $primary-color;\n            }\n        }\n        p {\n            margin: 0 0 5px;\n        }\n        .rating {\n            line-height: 0;\n            span {\n                color: #ffce00;\n                margin-right: 5px;\n            }\n        }\n        .view-link {\n            position: absolute;\n            top: 30px;\n            right: 10px;\n            border: 1px solid $primary-color;\n            color: $primary-color;\n            height: 30px;\n            width: 30px;\n            text-align: center;\n            display: inline-block;\n            line-height: 30px;\n            border-radius: 30px;\n            &:hover {\n                background: $primary-color;\n                color: #fff;\n            }\n        }\n    }\n}\n.tickets-lists {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    height: 365px;\n    overflow-y: auto;\n    li {\n        border-bottom: 1px solid $border-color;\n        position: relative;\n        padding-left: 65px;\n        padding-top: 15px;\n        padding-bottom: 15px;\n        padding-right: 40px;\n        img {\n            border: 1px solid #f3f3f3;\n            width: 50px;\n            height: 50px;\n            position: absolute;\n            left: 0;\n            top: 11px;\n        }\n        .product-title {\n            font-size: 13px;\n            color: $template-text-color;\n            font-weight: 500;\n            display: inline-block;\n            margin-bottom: 3px;\n            text-decoration: none;\n\n            &:hover {\n                color: $primary-color;\n            }\n        }\n        .date, .time {\n            color: #797979;\n            .icon {\n                width: 10px;\n                height: 10px;\n            }\n        }\n    }\n}\n.height-365 {\n    height: 365px;\n    overflow-y: auto;\n}\n.product-categories {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    li {\n        line-height: 25px;\n        position: relative;\n        padding-left: 16px;\n        &::before {\n            content: '';\n            border: 1.4px solid $primary-color;\n            width: 10px;\n            height: 10px;\n            position: absolute;\n            left: 0;\n            top: 7px;\n            border-radius: 50px;\n        }\n        a {\n            color: #797979;\n            text-decoration: none;\n            &:hover {\n                color: $primary-color;\n            }\n        }\n    }\n}\n.table {\n    thead {\n        background: #f3f6f9;\n    }\n    .bg-none {\n        background: none;\n    }\n    .border-none {\n        th {\n            border-top: none;\n            padding-top: 0;\n        }\n    }\n    th {\n        font-size: 13px;\n    }\n    th, td {\n        border-bottom: 1px solid #eee;\n    }\n    td {\n        color: #797979;\n    }\n    .badge {\n        font-weight: 500;\n        padding: 5px 7px;\n    }\n    a {\n        color: #797979;\n        text-decoration: none;\n\n        &:hover {\n            color: $primary-color;\n        }\n    }\n    tr.active {\n        background: #f3f6f9;\n    }\n}\n.table > :not(caption) > * > * {\n    padding: 11px 0.5rem;\n}\n.table-striped {\n    tbody {\n        tr {\n            &:nth-of-type(odd) {\n                background-color: #fff;\n            }\n            &:nth-of-type(even) {\n                background-color: #f3f6f9;\n            }\n        }\n    }\n}\n.table-hover {\n    tbody {\n        tr {\n            &:hover {\n                background-color: #f3f6f9;\n            }\n        }\n    }\n}\n.table-dark {\n    thead {\n        background: #212529;\n    }\n    td {\n        color: #fff;\n    }\n}\n/* End dashboard landing page v.1 style */\n\n/* Search result style */\n.search-result {\n    .single-product {\n        border: 1px solid $border-color;\n        padding-left: 100px;\n        padding-top: 20px;\n        padding-bottom: 20px;\n        padding-right: 45px;\n        margin-top: 20px;\n        border-radius: 6px;\n        img {\n            left: 20px;\n            top: 18px;\n        }\n        .view-link {\n            top: 35px;\n            right: 20px;\n        }\n    }\n}\n.page-link {\n    color: $primary-color;\n    &:hover {\n        color: #000;\n    }\n}\n.page-item.active .page-link {\n    background-color: $primary-color;\n    border-color: $primary-color;\n}\n/* End search result style */\n\n/* Notifications page style */\n.notifications-card {\n    .noti-card-title {\n        background: #fff;\n        margin: 0;\n        padding: 15px 20px;\n        border-top: 1px solid $border-color;\n        border-left: 1px solid $border-color;\n        border-right: 1px solid $border-color;\n        font-size: 15px;\n    }\n    .list-group {\n        .list-group-item {\n            border: 1px solid $border-color;\n            padding: 15px 15px 15px 40px;\n            position: relative;\n            font-size: 13px;\n            &:first-child {\n                border-top-left-radius: 0;\n                border-top-right-radius: 0;\n            }\n            a {\n                font-weight: 500;\n                color: $primary-color;\n                text-decoration: none;\n\n                &:hover {\n                    text-decoration: underline;\n                }\n            }\n            .icon {\n                position: absolute;\n                left: 15px;\n                top: 16px;\n                width: 16px;\n                height: 16px;\n            }\n            span {\n                position: absolute;\n                left: 15px;\n                top: 15px;\n                font-size: 18px;\n            }\n            .time {\n                position: absolute;\n                right: 15px;\n                top: 17px;\n                color: #a1aab2;\n                font-size: 13px;\n            }\n            ul {\n                list-style-type: none;\n                margin: 0;\n                padding: 0;\n                li {\n                    display: inline-block;\n                    margin-right: 5px;\n                    margin-top: 5px;\n                }\n            }\n            .content {\n                padding-top: 10px;\n            }\n            .media {\n                padding: 15px;\n                border: 1px solid $border-color;\n                border-radius: 5px;\n            }\n        }\n    }\n}\n.status {\n    position: absolute;\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n}\n.online {\n    background:#42b72a;\n}\n.ofline {\n    background: #f62d51;\n}\n.away {\n    background: #ffbc34; \n}\n/* End Notifications page style */\n\n.notification-card-one {\n    a {\n        text-decoration: none;\n    }\n}\n\n/* Todo list style */\n.todo-list {\n    ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n        li {\n            position: relative;\n            border: 1px solid $border-color;\n            padding: 15px 40px 15px 45px;\n            border-radius: 10px;\n            margin-top: 10px;\n\n            .task {\n                font-size: 14px;\n            }\n            .completed {\n                text-decoration: line-through;\n                color: cadetblue;\n            }\n        }\n        .close-btn {\n            background-color: transparent;\n            color: $danger-color;\n            position: absolute;\n            right: 15px;\n            top: 15px;\n            padding: 0;\n            height: 22px;\n            width: 22px;\n            font-size: 9px;\n            border-radius: 50%;\n            line-height: 22px;\n        }   \n    }\n    .add-new-task {\n        position: relative;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        .form-control {\n            border-color: $border-color;\n            border-radius: 0;\n            background: #eef5f9;\n            height: 42px;\n            box-shadow: none;\n        }\n        .btn-primary {\n            position: absolute;\n            top: 0;\n            right: 0;\n            border-radius: 0;\n            height: 42px;\n        }\n    }\n}\n.control {\n    display: block;\n    position: absolute;\n    cursor: pointer;\n    left: 15px;\n    top: 12px;\n    input {\n        position: absolute;\n        z-index: -1;\n        opacity: 0;\n    }\n    .control-indicator {\n        position: absolute;\n        top: 2px;\n        left: 0;\n        height: 22px;\n        width: 22px;\n        border: 1px solid #e6e6e6;\n        border-radius: 50%;\n    }\n}\n.control input:checked ~ .control-indicator {\n    background: $primary-color;\n}\n.control-indicator:after {\n    content: '';\n    position: absolute;\n    display: none;\n}\n.control input:checked ~ .control-indicator:after {\n    display: block;\n}\n.control-checkbox .control-indicator:after {\n    left: 7px;\n    top: 3px;\n    width: 6px;\n    height: 11px;\n    border: 1px solid #e6e6e6;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg)\n}\n/* End Todo list style */ \n \n/* Signup page style */\n.auth-main-content {\n    height: 100vh;\n    padding: 0 15px;\n}\n.auth-box {\n    max-width: 750px;\n    margin: 30px auto;\n    background: #fff; \n    border-radius: 10px;\n    position: relative;\n    box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n    padding-left: 15px;\n    padding-right: 15px;\n    &::before {\n        content: '';\n        position: absolute;\n        background: $border-color;\n        height: 100%;\n        width: 1px;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 0;\n    } \n}\n.form-left-content {\n    padding: 50px 30px 50px 30px;\n    .auth-logo {\n        text-align: center;\n        font-size: 25px;\n        color: $primary-color;\n        line-height: 1;\n    }\n    .login-links {\n        a {\n            display: block;\n            margin-top: 15px;\n            line-height: 1;\n            padding: 8px 15px;\n            border-radius: 30px;\n            text-align: center;\n            text-decoration: none;\n\n            .icon {\n                width: 15px;\n                height: 15px;\n                margin-right: 5px;\n                margin-top: -2px;\n            }\n            span {\n                padding-right: 5px;\n            }\n        }\n        .fb {\n            background: #3B5998;\n            color: #fff;\n            border: 1px solid #3B5998;\n            &:hover {\n                border-radius: 0;\n            }\n        }\n        .twi {\n            border: 1px solid #3CF; \n            background: #3CF;\n            color: #fff;\n            &:hover {\n                border-radius: 0;\n            }\n        }\n        .ema {\n            border: 1px solid #DC4A38;\n            background: #DC4A38;\n            color: #fff;\n            &:hover {\n                border-radius: 0;\n            }\n        }\n        .linkd {\n            border: 1px solid #007bb6;\n            background: #007bb6;\n            color: #fff;\n            &:hover {\n                border-radius: 0;\n            }\n        }\n    }\n}\n.form-content {\n    padding: 50px 30px 50px 30px;\n    .heading {\n        margin: 0 0 20px;\n        position: relative;\n        font-size: 18px;\n        border-bottom: 1px solid $border-color;\n        padding-bottom: 8px;\n        font-weight: 600;\n        &::before {\n            content: '';\n            background: $primary-color;\n            height: 1px;\n            width: 30px;\n            position: absolute;\n            left: 0;\n            bottom: -1px;\n        }\n    }\n    .form-control {\n        height: 35px;\n        border-radius: 30px; \n        border: 1px solid #ebebeb;\n    }\n    .btn-primary {\n        border-radius: 30px;\n        font-size: 13px;\n        padding: 10px 20px;\n        line-height: 1;\n        width: 100%;\n    }\n    .fp-link {\n        display: block;\n        margin-top: 15px;\n        max-width: 120px;\n        margin-left: auto;\n        margin-right: auto;\n        color: $template-text-color;\n        &:hover {\n            color: $primary-color;\n            text-decoration: underline;\n        }\n    }\n}\n.auth-bg-image {\n    background-image: url('../img/trailer_wearhouse.png');\n    background-position: center center;\n    background-attachment: fixed;\n    background-size: cover;\n}\n/* End signup page style */\n\n/* Notes page style */\n.notes-card {\n    position: relative;\n    button {\n        background: #f75d81;\n        border-color: #f75d81;\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        font-size: 10px;    \n        border-radius: 0;\n    }\n}\n.notes-content {\n    .form-control {\n        border-radius: 0;\n        border-color: $border-color;\n        box-shadow: none;\n        padding: 15px;\n        line-height: 26px; \n    }\n    form {\n        position: relative;\n        .btn {\n            position: absolute;\n            top: 0;\n            right: 0;\n        }\n    }\n}\n/* End notes page style */\n\n/* Map style */\n.map-content {\n    width: 100%;\n    height: 500px;\n}\n/* End map style */\n\n/* Calendar style */\n.react-calendar {\n    width: 100%;\n    margin-top: 20px;\n    border: 1px solid #e3e3e3;\n \n    button {\n        span {\n            font-weight: 600;\n            font-size: 15px;\n        }\n    }\n    .react-calendar__month-view__weekdays {\n        font-size: 13px; \n    }\n    .react-calendar__tile {\n        font-size: 14px;\n        border: 1px solid #eee !important;\n        padding: 30px 8px;\n    }\n}\n/* End Calendar style */\n\n/* List group */\n.card-header + .list-group .list-group-item:first-child {\n    border-top: 1px solid #ebebeb;\n    border-radius: 0;\n}\n.list-group-item:last-child {\n    border-radius: 0;\n}\n/* End List group */\n\n/* Modal style */\n.modal-dialog {\n    .modal-content {\n        border-radius: 0;\n        .modal-header {\n            padding: 20px 30px;\n            .modal-title {\n                font-size: 22px;\n                line-height: 1;\n            }\n        }\n        .modal-body {\n            padding: 30px;\n        }\n        .modal-footer {\n            padding: 20px 30px;\n        }\n    }\n    p {\n        line-height: 25px;\n    }\n}\n.modal-90w {\n    width: 90%;\n    max-width: none!important;\n}\n/* End Modal style */\n\n/* Tab style */\n.tab-content {\n    p {\n        margin-bottom: 10px;\n        &:last-child {\n            margin: 0;\n        }\n    }\n}\n.tabs-style-one {\n    .tab-content {\n        padding: 20px;\n        border-bottom: 1px solid $border-color;\n        border-left: 1px solid $border-color;\n        border-right: 1px solid $border-color;\n    }\n    .nav-tabs {\n        .nav-link {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n            color: #495057;\n        }\n    }\n}\n.tabs-style-two {\n    .tab-content {\n        padding: 20px;\n        border-bottom: 1px solid $border-color;\n        border-left: 1px solid $border-color;\n        border-right: 1px solid $border-color;\n    }\n    .nav-tabs {\n        .nav-link {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n            color: #495057;\n        }\n        .nav-link.active, .nav-item.show .nav-link {\n            color: #fff;\n            background-color: $primary-color;\n            border-color: $primary-color;\n        }\n    }\n}\n.tabs-style-three {\n    .tab-content {\n        padding: 20px;\n        border-bottom: 1px solid $border-color;\n        border-left: 1px solid $border-color;\n        border-right: 1px solid $border-color;\n    }\n    .nav-tabs {\n        .nav-link {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n            color: #495057;\n            border-top: 2px solid transparent;\n            &:hover {\n                border-top: 2px solid $primary-color;\n                border-bottom-color: #fff;\n            }\n        }\n        .nav-link.active, .nav-item.show .nav-link {\n            border-top: 2px solid $primary-color;\n        }\n    }\n}\n.pill-tab {\n    .nav {\n        border-bottom: 1px solid #ebebee;\n    }\n    .nav-pills {\n        .nav-link {\n            border-radius: 0;\n            color: #495057;\n            &:hover {\n                color: $primary-color;\n            }\n        }\n        .nav-link.active, .show > .nav-link {\n            color: #fff;\n            background-color: $pragraph-color;\n        }\n    }\n    .tab-content {\n        margin-top: 20px;\n    }\n}\n.vertical-pills-tab {\n    .nav-pills {\n        .nav-link {\n            border-radius: 0;\n            color: #495057;\n            &:hover {\n                color: $primary-color;\n            }\n        }\n        .nav-link.active, .show > .nav-link {\n            color: #fff;\n            background-color: $primary-color;\n        }\n    }\n}\n/* End Tab style */\n\n/* Inbox style */\n.inbox-main-sidebar {\n    .nav-pills {\n        margin-top: 20px;\n        .nav-link {\n            border-radius: 0px;\n            color: #47404f;\n            &:hover {\n                color: $primary-color;\n                background-color: #fff;\n            }\n        }\n        .nav-link.active {\n            color: $primary-color;\n            background-color: #fff;\n        }\n    }\n}\n.inbox-content-wrap {\n    background: #fff;\n}\ntextarea.form-control {\n    line-height: 22px;\n}\n.mail-item-nav {\n    border-right: 1px solid #eee;\n    height: 720px;\n    overflow-y: auto;\n\n    .nav-pills {\n        .nav-link {\n            border-radius: 0;\n            border-bottom: 1px solid #eee;\n            padding: 20px 15px;\n            position: relative;\n            overflow: hidden;\n\n            &:hover {\n                background-color: #fafafa;\n\n                &::before {\n                    content: '';\n                    position: absolute;\n                    right: -18px;\n                    background: $primary-color;\n                    height: 15px;\n                    width: 40px;\n                    -webkit-transform: rotate(90deg);\n                    transform: rotate(-45deg);\n                    bottom: 0;\n                }\n            }\n            img {\n                position: absolute;\n            }\n            .info {\n                padding-left: 40px;\n\n                .name {\n                    line-height: 1;\n                    color: #70657b;\n                    font-size: 13px;\n                    font-weight: 500;\n                }\n                p {\n                    color: #47404f;\n                    margin: 6px 0 0;\n                    line-height: 1;\n                    font-size: 12px;\n                }\n                .date {\n                    right: 15px;\n                    position: absolute;\n                    top: 20px;\n                    color: #797979;\n                    font-size: 11px;\n                    line-height: 1;\n                }\n            }\n        }\n        .nav-link.active{\n            background-color: #fafafa;\n            &::before {\n                content: '';\n                position: absolute;\n                right: -18px;\n                background: $primary-color;\n                height: 15px;\n                width: 40px;\n                -webkit-transform: rotate(90deg);\n                transform: rotate(-45deg);\n                bottom: 0;\n            }\n        }\n    }\n}\n.email-details-warp {\n    height: 720px;\n    overflow-y: auto;\n    padding: 30px 30px 30px 0;\n    position: relative;\n\n    p {\n        color: #797979;\n        font-size: 13px;\n    }\n    .inbox-topbar {\n        position: absolute;\n        top: 30px;\n        right: 30px;\n        .btn {\n            border-radius: 30px;\n            padding: 5px 10px;\n            font-size: 10px;\n        }\n    }\n}\n/* End Inbox style */\n\n/* Marketing content */\n.marketing-content {\n    .list {\n        position: relative;\n        padding-left: 50px;\n        margin-bottom: 11px;\n        border-bottom: 1px solid #eee;\n        padding-bottom: 11px;\n        &:last-child {\n            margin-bottom: 0;\n            border-bottom: none;\n            padding-bottom: 0;\n        }\n        > .icon {\n            width: 35px;\n            height: 35px;\n            color: #fff;\n            padding: 8px;\n            position: absolute;\n            left: 0;\n            top: 0;\n            border-radius: 2px;\n        }\n        .fb {\n            background: #4267b2;\n        }\n        .ins {\n            background: #A1755C;\n        }\n        .twi {\n            background: #1da1f2;\n        }\n        .lin {\n            background: #0077B5;\n        }\n        .ytb {\n            background: #ff0000;\n        }\n        h3 {\n            margin: 0;\n            font-size: 13px;\n            a {\n                color: #47404f;\n                text-decoration: none;\n\n                &:hover {\n                    color: $primary-color;\n                }\n            }\n        }\n        p {\n            margin: 7px 0 0;\n            line-height: 1;\n            font-size: 12px;\n        }\n        .stats {\n            position: absolute;\n            right: 0;\n            top: 0;\n            .icon {\n                width: 14px;\n                height: 14px;\n                margin-right: 8px;\n            }\n        }\n    }\n}\n/* End Marketing content */\n\n/* New customer card */\n.new-customer {\n    position: relative;\n    padding-left: 52px;\n    padding-top: 5px;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eee;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    .profile {\n        position: absolute;\n        left: 0;\n        top: 0;\n\n        img {\n            width: 40px;\n            height: 40px;\n        }\n    }\n\n    .price {\n        position: absolute;\n        right: 0;\n        top: 8px;\n        font-size: 14px;\n        font-weight: 500;\n    }\n}\n/* End new customer card */\n\n/* Search contact */\n.search-contact {\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n    .form-control {\n        height: 41px;\n    }\n}\n.chat-header {\n    border-bottom: 1px solid #eee;\n    padding: 8px 0;\n    margin-right: 30px;\n}\n.chat-details-warp {\n    padding: 30px 30px 110px 0;\n}\n.chat-list-right {\n    position: relative;\n    padding-right: 60px;\n    margin-bottom: 20px;\n    > img {\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n    .chat-details {\n        background: #fafafa;\n        position: relative;\n        padding: 20px 20px 10px;\n        &::before {\n            position: absolute;\n            content: \"\";\n            top: 14px;\n            right: -5px;\n            background: 0 0;\n            border-style: solid;\n            border-width: 0 12px 12px 0;\n            border-color: transparent transparent #fafafa;\n            -webkit-transform: rotate(-135deg);\n            transform: rotate(-135deg);\n        }\n        .name {\n            font-size: 15px;\n        }\n        .date {\n            position: absolute;\n            top: 20px;\n            right: 20px;\n            color: #797979;\n            font-size: 12px;\n        }\n    }\n}\n.chat-list-left {\n    position: relative;\n    padding-left: 60px;\n    margin-bottom: 20px;\n    > img {\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n    .chat-details {\n        background: #fafafa;\n        position: relative;\n        padding: 20px 20px 10px;\n        &::before {\n            position: absolute;\n            content: \"\";\n            top: 14px;\n            left: -5px;\n            background: 0 0;\n            border-style: solid;\n            border-width: 0 12px 12px 0;\n            border-color: transparent transparent #fafafa;\n            -webkit-transform: rotate(-135deg);\n            transform: rotate(45deg);\n        }\n        .name {\n            font-size: 15px;\n        }\n        .date {\n            position: absolute;\n            top: 20px;\n            right: 20px;\n            color: #797979;\n            font-size: 12px;\n        }\n    }\n}\n.chat-box {\n    background: #fff;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding-right: 30px;\n    padding-bottom: 30px;\n}\n/* End Search contact */\n\n/* Order stats card */\n.order-stats-card {\n    position: relative;\n    h3 {\n        margin: 0;\n        font-size: 13px;\n    }\n}\n.order-number-stats {\n    text-align: center;\n    .number {\n        font-weight: 500;\n        font-size: 18px;\n    }\n    p {\n        margin: 0;\n        line-height: 1;\n    }\n}\n/* End order stats card */\n\n/* Visitor stats card */\n.visitor-stats {\n    background-color: #fff;\n    padding: 20px;\n    position: relative;\n    border-radius: 4px;\n    box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n    text-align: center;\n    h3 {\n        margin: 0;\n        font-size: 22px;\n    }\n    p {\n        margin: 5px 0 10px;\n        line-height: 1;\n        .icon {\n            width: 15px;\n            height: 15px;\n            margin: 0 5px;\n        }\n    }\n}\n/* End visitor stats card */\n\n/* Profile page style */\n.profile-header {\n    background-color: #fff;\n    padding: 30px;\n    text-align: center;\n    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n    border-radius: 4px;\n    .name {\n        margin: 0;\n        font-size: 18px;\n    }\n    p {\n        margin: 5px auto 0;\n        max-width: 690px;\n        line-height: 22px;\n    }\n    .profile-stats {\n        a {\n            display: inline-block;\n            margin-top: 10px;\n            margin-left: 8px;\n            margin-right: 8px;\n            color: #797979;\n            text-decoration: none;\n            strong {\n                color: #000;\n            }\n            &:hover strong {\n                color: $primary-color;\n            }\n        }\n    }\n}\n.profile-left-content {\n    .info {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n        li {\n            line-height: 22px;\n            position: relative;\n            color: $pragraph-color;\n            padding-left: 20px;\n            margin-bottom: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            .icon {\n                width: 14px;\n                height: 14px;\n                color: #000;\n                position: absolute;\n                left: 0;\n                top: 3px;            \n            }\n        }\n    }\n}\n.profile-middle-content {\n    background-color: #fff;\n    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n    border-radius: 4px;\n}\n.post-card {\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    .content {\n        h5 {\n            font-size: 15px;\n            margin-bottom: 5px;\n            line-height: 22px;\n            a {\n                color: #47404f;\n                text-decoration: none;\n                \n                &:hover {\n                    color: $primary-color;\n                }\n            }\n        }\n        p {\n            margin: 0 0 10px;\n        }\n    }\n    .feed-back {\n        a {\n            color: #797979;\n            margin-right: 15px;\n            border-right: 1px solid #eee;\n            padding-right: 10px;\n            text-decoration: none;\n\n            &:hover {\n                color: $primary-color;\n            }\n            &:last-child {\n                border-right: none;\n                padding-right: 0;\n            }\n            .icon {\n                width: 17px;\n                height: 17px;\n                margin-right: 5px;\n                margin-top: -2px;\n            }\n        }\n    }\n}\n.profile-right-content {\n    .connecting-list {\n        height: 255px;\n        overflow-x: hidden;\n    }\n    .list-content {\n        border-bottom: 1px solid #eee;\n        margin-bottom: 12px;\n        padding-bottom: 12px;\n\n        &:last-child {\n            margin-bottom: 0;\n            padding-bottom: 0;\n            border-bottom: none;\n        }\n        h5 {\n            margin: 0 0 8px;\n            font-size: 12px;\n\n            a {\n                color: #47404f;\n                text-decoration: none;\n\n                &:hover {\n                    color: $primary-color;\n                }\n            }\n        }\n        .btn {\n            font-size: 10px;\n            padding: 5px 12px;\n        }\n    }\n}\n/* Profile page style */\n.profile-settings-form {\n    padding: 30px;\n    background-color: #fff;\n    border-radius: 4px;\n    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n    max-width: 800px;\n    margin: auto;\n}\n/* Users card */\n.single-user-card {\n    background-color: #fff;\n    text-align: center;\n    border-radius: 4px;\n    box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n    img {\n        background-color: #e0e0e0;\n        height: 120px;\n        width: 120px;\n    }\n    h4 {\n        font-size: 18px;\n    }\n    .social-links {\n        a {\n            display: inline-block;\n            margin: 0 5px;\n            color: #797979;\n            &:hover {\n                color: $primary-color;\n            }\n            .icon {\n                width: 15px;\n                height: 15px;\n            }\n        }\n    }\n    .user-card-foot {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n        border-top: 1px solid #eee;\n        li {\n            display: inline-block;\n            display: inline-block;\n            width: 33.33%;\n            padding-top: 10px;\n            padding-bottom: 10px;\n            padding-left: 10px;\n            padding-right: 10px;\n            color: #797979;\n\n            span {\n                display: block;\n                font-weight: 500;\n                font-size: 18px;\n                color: #47404f;\n            }\n        }\n        .bor-lr {\n            border-left: 1px solid #eee;\n            border-right: 1px solid #eee;\n        }\n    }\n}\n.octagon-style {\n    -webkit-clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n}\n.nonagon-style {\n    -webkit-clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);\n    clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);\n}\n.bevel-style {\n    -webkit-clip-path: polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);\n    clip-path: polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);\n}\n/* End Users card */\n\n/* TimeLine Style */\n.timeline-centered {\n    position: relative;\n    margin-bottom: 30px;\n    &:before, &:after {\n        content: \"\";\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n    &:before {\n        content: '';\n        position: absolute;\n        display: block;\n        width: 4px;\n        background: #fff;\n        left: 50%;\n        top: 20px;\n        bottom: 20px;\n        margin-left: -4px;\n    }\n    .timeline-card {\n        position: relative;\n        width: 50%;\n        float: right;\n        margin-bottom: 40px;\n        clear: both;\n        &:before, &:after {\n            content: \" \";\n            display: table;\n        }\n        &:after {\n            clear: both;\n        }\n        &:before, &:after {\n            content: \" \";\n            display: table;\n        }\n        &:after {\n            clear: both;\n        }\n    }\n    .timeline-card.begin {\n        margin-bottom: 0;\n    }\n    .timeline-card.left-aligned {\n        float: left;\n        .timeline-body {\n            margin-left: 0;\n            margin-right: -18px;\n            .time {\n                left: auto;\n                right: -100px;\n                text-align: left;\n            }\n            .timeline-icon {\n                float: right;\n            }\n            .timeline-label {\n                margin-left: 0;\n                margin-right: 70px;\n                &:after {\n                    left: auto;\n                    right: 0;\n                    margin-left: 0;\n                    margin-right: -9px;\n                    -moz-transform: rotate(180deg);\n                    -o-transform: rotate(180deg);\n                    -webkit-transform: rotate(180deg);\n                    -ms-transform: rotate(180deg);\n                    transform: rotate(180deg);\n                }\n            }\n        }\n    }\n    .timeline-card {\n        .timeline-body {\n            position: relative;\n            margin-left: -22px;\n            &:before, &:after {\n                content: \" \";\n                display: table;\n            }\n            &:after {\n                clear: both;\n            }\n            &:before, &:after {\n                content: \" \";\n                display: table;\n            }\n            &:after {\n                clear: both;\n            }\n            .time {\n                position: absolute;\n                left: -100px;\n                text-align: right;\n                > span {\n                    display: block;\n                }\n                > span:first-child {\n                    font-size: 15px;\n                    font-weight: 500;\n                }\n                > span:last-child {\n                    font-size: 12px;\n                    color: #797979;\n                }\n            }\n            .timeline-icon {\n                background: #fff;\n                color: #737881;\n                display: block;\n                width: 40px;\n                height: 40px;\n                border-radius: 30px;\n                text-align: center;\n                box-shadow: 0 0 0 4px #fff;\n                line-height: 40px;\n                font-size: 15px;\n                float: left;\n            }\n            .timeline-label {\n                position: relative;\n                background: #fff;\n                box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n                padding: 1.7em;\n                margin-left: 70px;\n                border-radius: 4px;\n                &:after {\n                    content: '';\n                    display: block;\n                    position: absolute;\n                    width: 0;\n                    height: 0;\n                    border-style: solid;\n                    border-width: 10px 10px 10px 0;\n                    border-color: transparent #fff transparent transparent;\n                    left: 0;\n                    top: 10px;\n                    margin-left: -9px;\n                }\n                h3 {\n                    font-size: 18px;\n                    margin-bottom: 5px;\n                    line-height: 25px;\n                }\n                p {\n                    margin-top: 5px;\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n} \n.timeline-icon.bg-purple {\n    background-color: $purple-color !important;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-primary {\n    background-color: $primary-color;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-secondary {\n    background-color: #ee4749;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-success {\n    background-color: $success-color;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-info {\n    background-color: #21a9e1;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-warning {\n    background-color: #fad839;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n.timeline-icon.bg-danger {\n    background-color: $danger-color;\n    color: #fff;\n    .icon {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n        margin-top: -2px;\n    }\n}\n/* End TimeLine Style */\n\n/* Invoice Template */\n.invoice-template {\n    background: #fff;\n    padding: 20px;\n\n    .invoice-header {\n        position: relative;\n        border-bottom: 1px solid #eee;\n        padding-bottom: 15px;\n\n        h3 {\n            margin: 0;\n            font-size: 20px;\n            text-transform: uppercase;\n        }\n        p {\n            color: #47404f;\n            position: absolute;\n            top: 0;\n            right: 0;\n            font-weight: 500;\n            font-size: 18px;\n        }\n    }\n}\n/* End Invoice Template */\n\n/* Error page design */\n.error-content {\n    padding: 30px;\n    text-align: center;\n    height: 100vh;\n    .icon {\n        width: 50px;\n        height: 50px;\n        color: $pragraph-color;\n    }\n    h1 {\n        font-size: 100px;\n        font-weight: bolder;\n    }\n    h3 {\n        margin: 0;\n    }\n    p {\n        margin: auto;\n        max-width: 500px;\n    }\n    .back-link {\n        background-color: $primary-color;\n        color: #fff;\n        display: inline-block;\n        border: 1px solid $primary-color;\n        padding: 10px 30px;\n        border-radius: 100px;\n        margin-top: 30px;\n        text-decoration: none;\n\n        &:hover {\n            background-color: #333;\n            border-color: #333;\n        }\n    }\n}\n/* End error page design */\n\n/* Map Style */\n.map-height-500 {\n    height: 500px;\n}\n.jvectormap-container {\n    padding: 20px;\n}\n/* End Map Style */\n\n/* Apexcharts content */\n.apexcharts-content {\n    width: 100%;\n    .toolbar {\n        margin-left: 45px;\n        button {\n            background: #fff;\n            color: #222;\n            border: 1px solid #e7e7e7;\n            border-bottom: 2px solid #ddd;\n            border-radius: 2px;\n            padding: 4px 17px;\n            cursor: pointer;\n        }\n        button.active {\n            color: #fff;\n            background: $primary-color;\n            border: 1px solid $primary-color;\n            border-bottom: 2px solid $primary-color;\n        }\n    } \n}\n/* End Apexcharts content */\n\n/* Accordion style  */\n.custom-accordion {\n    .heading {\n        margin-bottom: 20px;\n        font-size: 20px;\n    }\n    .accordion__item + .accordion__item {\n        border-top: 1px solid #eee;\n    }\n    .accordion__button {\n        position: relative;\n        background-color: #fff;\n        padding: 20px;\n        font-weight: 500;\n        &:focus {\n            outline: 0;\n        } \n        font-size: 17px; \n        \n        &:hover {\n            color: $primary-color;\n        }\n        &:before {\n            float: right;\n            margin-top: 7px;\n        }\n    } \n    .accordion__panel {\n        background-color: #fff;\n        border-top: 1px solid #eee;\n        p {\n            margin-bottom: 10px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}\n/* End accordion style  */\n\n/* Icon preview style */\n.icon-preview {\n    background-color: #fff;\n    border-radius: 4px;\n    padding: 20px;\n    position: relative;\n    \n    span {\n        padding-left: 10px;\n        font-size: 15px;\n        color: #777;\n        position: absolute;\n        margin-top: 2px;\n    }\n}\n/* End Icon preview style */\n\n/* Switch Button */\n.side-menu-switch {\n    position: absolute;\n    top: 92px;\n    right: 30px;\n    z-index: 5;\n    .switch {\n        position: relative;\n        display: inline-block;\n        width: 45px;\n        height: 26px;\n        input { \n            display:none;\n        }\n        .slider {\n            position: absolute;\n            cursor: pointer;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: #2c2f48;\n            -webkit-transition: .4s;\n            transition: .4s;\n            &:before {\n                position: absolute;\n                content: \"\";\n                height: 20px;\n                width: 20px;\n                left: 4px;\n                background-color: white;\n                top: 3px;\n                transition: .4s;\n                -webkit-transition: .4s;\n            }\n        }\n        input.light:checked + .slider {\n            background-color: #fff;\n            &:before {\n                background-color: $primary-color;\n            }\n        }\n        input:checked + .slider:before {\n            -webkit-transform: translateX(18px);\n            -ms-transform: translateX(18px);\n            transform: translateX(18px);\n        }    \n        .slider.round {\n            border-radius: 30px;\n            box-shadow: 0 0 8px #ddd;\n        }\n        .slider.round:before {\n            border-radius: 50%;\n        }\n    }\n}\n/* End Switch Button */\n\n/* Pricing Table style */\n.pricing-table {\n    background: #fff;\n    border-radius: 4px;\n    text-align: center;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease 0s;\n    svg {\n        display: block;\n        margin-left: -1px;\n    }\n    .price {\n        position: absolute;\n        top: 0;\n        color: #fff;\n        font-size: 55px;\n        font-weight: bold;\n        text-align: center;\n        width: 100%;\n        margin: 0;\n        top: 50%;\n        transform: translateY(-70%);\n        -webkit-transform: translateY(-70%);\n        span {\n            display: block;\n            font-size: 15px;\n            font-weight: 300;\n            padding-left: 60px;\n        }\n    }\n    .pricing-content {\n        padding: 40px 0 30px;\n        position: relative;\n    }\n    .title {\n        font-size: 25px;\n        font-weight: 600;\n        text-transform: uppercase;\n        margin: 0 0 10px 0;\n    }\n    .pricing-content {\n        ul {\n            padding: 0;\n            margin: 20px 0;\n            list-style-type: none;\n            li {\n                font-size: 15px;\n                line-height: 40px;\n                border-top: 1px solid #eee;\n                color: #656565;\n            }\n        }\n    }\n    .signup {\n        display: inline-block;\n        padding: 8px 50px;\n        border-radius: 20px;\n        font-size: 18px;\n        color: #fff;\n        text-transform: uppercase;\n        position: relative;\n        transition: all 0.3s ease 0s;\n    }\n}\n/* End Pricing Table style */\n\n/* Footer Style */\n.footer {\n    background: #fff;\n    padding: 15px 30px;\n    text-align: center;\n    -webkit-clip-path: polygon(1% 0, 99% 0, 100% 100%, 0% 100%);\n    clip-path: polygon(1% 0, 99% 0, 100% 100%, 0% 100%);\n    border-radius: 30px 30px 0 0;\n    p {\n        margin: 0;\n        color: #5a5151;\n        a {\n            color: $primary-color;\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n}\n/* End Footer Style */\n \n","/*\nTable Of Content\n=================================\n* Color system\n* Body\n* Typography\n* Todos\n* Calendar\n* Notes\n* Search\n* Notifications\n* Breadcrumbs\n* Alerts\n* Badges\n* Buttons\n* Cards\n* Dropdowns\n* Forms\n* List Groups\n* Modals\n* Progress bars\n* Tables\n* Tabs\n* Signup\n* Login\n* Forgot Password\n*/\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i\");\n@import url(../css/LineIcons.min.css);\n@import url(\"https://cdnjs.cloudflare.com/ajax/libs/jvectormap/2.0.4/jquery-jvectormap.css\");\n/* Default color & font Variables */\n/* End default color & font Variables */\n/* Default style */\nbody {\n  background-color: #f3f6f9;\n  color: #47404f;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n}\n\na {\n  transition: 0.4s;\n  -webkit-transition: 0.4s;\n}\na:hover {\n  text-decoration: none;\n  color: #2962ff;\n}\n\np {\n  color: #797979;\n  line-height: 24px;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.input-group-text {\n  padding: 3px 13px;\n}\n\niframe {\n  border: 0;\n}\n\n.form-select {\n  font-size: 13px;\n}\n\n/* Scrollbar style */\n::-webkit-scrollbar {\n  width: 4px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px #ebebee;\n  border-radius: 30px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 30px;\n  background: #2962ff;\n  box-shadow: inset 0 0 6px #ebebee;\n}\n\n::-webkit-scrollbar-thumb:window-inactive {\n  background: #2962ff;\n}\n\n/* End Scrollbar style */\nbutton:focus {\n  outline: 0;\n}\n\n.btn {\n  font-size: 13px;\n  padding: 10px 15px;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.badge {\n  padding-right: 10px;\n  padding-left: 10px;\n  font-size: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.btn-outline-light {\n  color: #848484;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 10px 25px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.btn-md {\n  padding: 10px 20px;\n  font-size: 15px;\n}\n\n.btn-xs {\n  padding: 8px 16px;\n  font-size: 13px;\n}\n\n.radius-0 {\n  border-radius: 0 !important;\n}\n\n.dropdown-item {\n  font-size: 14px;\n}\n\n.btn-warning {\n  color: #fff;\n}\n.btn-warning:hover {\n  color: #fff;\n}\n\n.btn-outline-warning:hover {\n  color: #fff;\n}\n\n.form-control {\n  border-radius: 4px;\n  border-color: #ebebee;\n  font-size: 13px;\n  box-shadow: none;\n}\n.form-control:focus {\n  box-shadow: none;\n  border-color: #2962ff;\n}\n\n.form-group .form-text {\n  margin-top: 10px;\n  font-size: 12px;\n}\n.form-group > label {\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.form-check-input {\n  margin-top: 2px;\n}\n\n.custom-control-label {\n  padding-top: 4px;\n}\n\n.input-group-text {\n  color: #fff;\n  background-color: #2962ff;\n  border-radius: 0;\n}\n\n.loader {\n  top: 20px;\n  position: absolute;\n  left: 60%;\n  text-align: center;\n}\n\n/* End Default style */\n/* Helper class */\n.fs-10 {\n  font-size: 10px;\n}\n\n.fs-11 {\n  font-size: 11px;\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.fs-13 {\n  font-size: 13px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-15 {\n  font-size: 15px;\n}\n\n.fs-18 {\n  font-size: 18px;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n\n.fs-22 {\n  font-size: 22px;\n}\n\n.fs-40 {\n  font-size: 40px;\n}\n\n.fs-50 {\n  font-size: 50px;\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.mr-5 {\n  margin-right: 5px !important;\n}\n\n.mr-10 {\n  margin-right: 10px;\n}\n\n.mb-20 {\n  margin-bottom: 20px !important;\n}\n\n.mt-40 {\n  margin-top: 40px;\n}\n\n.mt-minus-1 {\n  margin-top: -1px;\n}\n\n.mt-minus-2 {\n  margin-top: -2px;\n}\n\n.mt-minus-3 {\n  margin-top: -3px;\n}\n\n.mt-minus-4 {\n  margin-top: -4px;\n}\n\n.mt-minus-5 {\n  margin-top: -5px;\n}\n\n.pr-70 {\n  padding-right: 70px;\n}\n\n.p-30 {\n  padding: 30px;\n}\n\n.fr {\n  float: right;\n}\n\n.wh-13 {\n  width: 13px;\n  height: 13px;\n  margin-top: -2px;\n}\n\n.wh-15 {\n  width: 15px;\n  height: 15px;\n}\n\n.wh-30 {\n  width: 30px;\n  height: 30px;\n}\n\n.wh-35 {\n  width: 35px;\n  height: 35px;\n}\n\n.wh-40 {\n  width: 40px;\n  height: 40px;\n}\n\n.w-80 {\n  width: 80px;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.mw-350 {\n  max-width: 350px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.relative {\n  position: relative;\n}\n\n.border {\n  border: 1px solid #ebebee;\n}\n\n.black-text {\n  color: #47404f !important;\n}\n\n.primary-text {\n  color: #2962ff !important;\n}\n\n.purple-text {\n  color: #7266ba !important;\n}\n\n.success-text {\n  color: #7ed320 !important;\n}\n\n.danger-text {\n  color: #f75d81 !important;\n}\n\n.theme-color {\n  color: #2962ff;\n}\n\n.danger-color {\n  color: #f75d81;\n}\n\n.global-color {\n  color: #47404f;\n}\n\n.gray-color {\n  color: #a1aab2;\n}\n\n.light-blue-bg {\n  background: #42a5f6;\n}\n\n.purple-bg {\n  background: #7266ba;\n}\n\n.primary-bg {\n  background: #2962ff;\n}\n\n.success-bg {\n  background: #7ed320;\n}\n\n.danger-bg {\n  background: #f75d81;\n}\n\n.theme-bg {\n  background-color: #2962ff !important;\n}\n\n.right {\n  right: 0;\n}\n\n.bottom {\n  bottom: 0;\n}\n\n.right-3 {\n  right: 3px;\n}\n\n.bottom-2 {\n  bottom: 2px;\n}\n\n.bottom-3 {\n  bottom: 3px;\n}\n\n.d-table {\n  width: 100%;\n  height: 100%;\n}\n\n.d-tablecell {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.border-radius-fl-item .page-item:first-child .page-link {\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n}\n.border-radius-fl-item .page-item:last-child .page-link {\n  border-top-right-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.height-408 {\n  height: 408px;\n  overflow-y: auto;\n}\n\n.height-310 {\n  height: 310px;\n  overflow-y: auto;\n}\n\n.height-500 {\n  height: 500px;\n  overflow-y: auto;\n}\n\n.rounded {\n  border-radius: 50px !important;\n}\n\n.alert-light {\n  background-color: #f9f9f9;\n  border-color: #f9f9f9;\n}\n\n.alert:last-child {\n  margin-bottom: 0;\n}\n\n.alert-dismissible .close {\n  padding: 0.6rem 1.2rem;\n}\n\n.white-color {\n  color: #fff;\n}\n\n.card-img-overlay {\n  background: rgba(41, 98, 255, 0.5);\n}\n.card-img-overlay .card-title {\n  color: #fff !important;\n}\n\n.alert-success p {\n  color: #155724;\n}\n\n.dropdown-menu {\n  border-radius: 0;\n}\n.dropdown-menu .dropdown-item {\n  font-size: 13px;\n  color: #797979;\n}\n\n.badge-warning {\n  color: #fff;\n}\n\n.btn-primary {\n  background-color: #2962ff;\n  border-color: #2962ff;\n}\n.btn-primary:hover {\n  background-color: #2962ff;\n  border-color: #2962ff;\n  opacity: 0.7;\n}\n\n.btn-outline-primary {\n  color: #2962ff;\n  border-color: #2962ff;\n}\n.btn-outline-primary:hover {\n  background-color: #2962ff;\n  border-color: #2962ff;\n}\n\n/* End helper class */\n/* Main content style */\n.main-content {\n  width: 100%;\n  margin-top: 62px;\n  transition: all 0.5s ease-in-out;\n  -webkit-transition: all 0.5s ease-in-out;\n  padding: 30px 30px 0;\n  position: relative;\n  min-height: calc(100vh - 62px);\n  padding-left: 244px;\n  overflow: hidden;\n}\n\n/* End main content style */\n/* Dashboard landing page v.1 style */\n.main-content-header {\n  margin-bottom: 20px;\n  border-bottom: 1px solid #ebebee;\n  padding-bottom: 10px;\n}\n.main-content-header h1 {\n  margin: 0;\n  font-size: 18px;\n  padding-right: 15px;\n}\n.main-content-header .breadcrumb {\n  padding: 0;\n  margin-bottom: 0;\n  background-color: transparent;\n}\n.main-content-header .breadcrumb .breadcrumb-item {\n  margin-top: 1px;\n}\n.main-content-header .breadcrumb a {\n  color: #47404f;\n  text-decoration: none;\n}\n.main-content-header .breadcrumb a:hover {\n  color: #2962ff;\n}\n\n.single-sales-card .card-body {\n  padding: 0 !important;\n}\n.single-sales-card .card-body .icon {\n  background: rgba(0, 0, 0, 0.1);\n  color: #fff;\n  width: 80px;\n  height: 80px;\n  padding: 22px;\n  border-radius: 4px 0 0 4px;\n}\n.single-sales-card .card-body .content p {\n  color: #fff;\n  line-height: 1;\n}\n\n.card {\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n  border-radius: 4px;\n  border: initial;\n}\n.card .card-body {\n  padding: 20px;\n}\n.card .card-header {\n  background-color: transparent;\n  padding: 0;\n  border-bottom: 1px solid #ebebee;\n  position: relative;\n  margin-bottom: 20px;\n}\n.card .card-header::before {\n  content: \"\";\n  background: #2962ff;\n  height: 1px;\n  width: 30px;\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n}\n.card .card-header .day {\n  background-color: #2962ff;\n  position: absolute;\n  bottom: 2px;\n  right: 0;\n  color: #fff;\n  display: inline-block;\n  font-size: 10px;\n  padding: 5px 10px 5px 22px;\n  -webkit-clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 16% 50%, 0% 0%);\n  clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 16% 50%, 0% 0%);\n}\n.card .card-title {\n  font-size: 15px;\n  padding-bottom: 10px;\n  padding: 0;\n  color: #323332;\n}\n.card .header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  color: inherit;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  font-weight: 600;\n}\n.card .header::before {\n  right: 0;\n  margin: auto;\n}\n.card .content {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 120px;\n}\n\n.card-dropdown .btn {\n  border-radius: 30px;\n  font-size: 15px;\n  padding: 0;\n  line-height: 25px;\n  background: #fff;\n  color: #2962ff;\n  height: 25px;\n  width: 25px;\n  margin-top: -5px;\n}\n.card-dropdown .btn .icon {\n  width: 18px;\n  height: 18px;\n}\n.card-dropdown .btn:hover {\n  background: #2962ff;\n  color: #fff;\n}\n.card-dropdown .btn:after {\n  display: none;\n}\n.card-dropdown .dropdown-menu.show {\n  left: auto !important;\n  right: 0 !important;\n  transform: inherit !important;\n  top: 24px !important;\n  border-radius: 0;\n}\n.card-dropdown .dropdown-item {\n  font-size: 13px;\n  padding: 0.4rem 1rem;\n  white-space: pre-wrap;\n  font-weight: 300;\n}\n.card-dropdown .dropdown-item.active, .card-dropdown .dropdown-item:active {\n  color: #16181b;\n  background-color: #f8f9fa;\n}\n\n.card-header .select-month-form {\n  position: absolute;\n  right: 0;\n  bottom: -1px;\n}\n.card-header .select-month-form .form-control {\n  height: 30px;\n}\n\n.hover-card {\n  transition: all 0.3s ease;\n}\n.hover-card:hover {\n  transform: translateY(-4px) scale(1.01);\n  box-shadow: 0 15px 25px rgba(60, 50, 100, 0.1);\n}\n\n/* stats card */\n.stats-card {\n  background-color: #fff;\n  padding: 20px;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n}\n.stats-card h3 {\n  margin: 0;\n  font-size: 22px;\n}\n.stats-card h3 .icon {\n  margin-left: 5px;\n  width: 18px;\n  height: 18px;\n  margin-top: -4px;\n}\n.stats-card p {\n  margin: 5px 0 0;\n  line-height: 1;\n}\n.stats-card i {\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #fff;\n  height: 50px;\n  width: 50px;\n  border-radius: 30px 0 30px 30px;\n  transition: 0.5s;\n  text-align: center;\n  line-height: 50px;\n  font-size: 25px;\n}\n.stats-card:hover i {\n  height: 100%;\n  border-radius: 0 4px 4px 0;\n  width: 70px;\n  line-height: 85px;\n  font-size: 35px;\n}\n.stats-card:hover .icon-hover {\n  height: 60px;\n  width: 60px;\n  line-height: 60px;\n  border-radius: 30px 0 30px 30px;\n  font-size: 30px;\n}\n.stats-card .stats-icon {\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #fff;\n  height: 50px;\n  width: 50px;\n  padding: 10px;\n  border-radius: 30px 0 30px 30px;\n  transition: 0.5s;\n}\n.stats-card:hover .stats-icon {\n  height: 100%;\n  border-radius: 0 4px 4px 0;\n  width: 70px;\n  padding: 15px;\n}\n\n.purple-card h3 .icon {\n  color: #7266ba;\n}\n.purple-card .stats-icon {\n  background: #7266ba;\n}\n.purple-card i {\n  background: #7266ba;\n}\n.purple-card .progress .progress-bar {\n  background-color: #7266ba !important;\n}\n\n.light-blue-card h3 .icon {\n  color: #42a5f6;\n}\n.light-blue-card .stats-icon {\n  background: #42a5f6;\n}\n.light-blue-card i {\n  background: #42a5f6;\n}\n.light-blue-card .progress .progress-bar {\n  background-color: #42a5f6 !important;\n}\n\n.success-card h3 .icon {\n  color: #7ed320;\n}\n.success-card .stats-icon {\n  background: #7ed320;\n}\n.success-card i {\n  background: #7ed320;\n}\n.success-card .progress .progress-bar {\n  background-color: #7ed320 !important;\n}\n\n.danger-card h3 .icon {\n  color: #f75d81;\n}\n.danger-card .stats-icon {\n  background: #f75d81;\n}\n.danger-card i {\n  background: #f75d81;\n}\n.danger-card .progress .progress-bar {\n  background-color: #f75d81 !important;\n}\n\n/* End stats card */\n.top-rated-products {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.top-rated-products .single-product {\n  border-bottom: 1px solid #ebebee;\n  position: relative;\n  padding-left: 80px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  padding-right: 45px;\n}\n.top-rated-products .single-product img {\n  border: 1px solid #f3f3f3;\n  width: 65px;\n  height: 65px;\n  position: absolute;\n  left: 0;\n  top: 14px;\n}\n.top-rated-products .single-product .product-title {\n  font-size: 13px;\n  color: #47404f;\n  font-weight: 500;\n  line-height: 1;\n  text-decoration: none;\n}\n.top-rated-products .single-product .product-title:hover {\n  color: #2962ff;\n}\n.top-rated-products .single-product p {\n  margin: 0 0 5px;\n}\n.top-rated-products .single-product .rating {\n  line-height: 0;\n}\n.top-rated-products .single-product .rating span {\n  color: #ffce00;\n  margin-right: 5px;\n}\n.top-rated-products .single-product .view-link {\n  position: absolute;\n  top: 30px;\n  right: 10px;\n  border: 1px solid #2962ff;\n  color: #2962ff;\n  height: 30px;\n  width: 30px;\n  text-align: center;\n  display: inline-block;\n  line-height: 30px;\n  border-radius: 30px;\n}\n.top-rated-products .single-product .view-link:hover {\n  background: #2962ff;\n  color: #fff;\n}\n\n.tickets-lists {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  height: 365px;\n  overflow-y: auto;\n}\n.tickets-lists li {\n  border-bottom: 1px solid #ebebee;\n  position: relative;\n  padding-left: 65px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  padding-right: 40px;\n}\n.tickets-lists li img {\n  border: 1px solid #f3f3f3;\n  width: 50px;\n  height: 50px;\n  position: absolute;\n  left: 0;\n  top: 11px;\n}\n.tickets-lists li .product-title {\n  font-size: 13px;\n  color: #47404f;\n  font-weight: 500;\n  display: inline-block;\n  margin-bottom: 3px;\n  text-decoration: none;\n}\n.tickets-lists li .product-title:hover {\n  color: #2962ff;\n}\n.tickets-lists li .date, .tickets-lists li .time {\n  color: #797979;\n}\n.tickets-lists li .date .icon, .tickets-lists li .time .icon {\n  width: 10px;\n  height: 10px;\n}\n\n.height-365 {\n  height: 365px;\n  overflow-y: auto;\n}\n\n.product-categories {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.product-categories li {\n  line-height: 25px;\n  position: relative;\n  padding-left: 16px;\n}\n.product-categories li::before {\n  content: \"\";\n  border: 1.4px solid #2962ff;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  left: 0;\n  top: 7px;\n  border-radius: 50px;\n}\n.product-categories li a {\n  color: #797979;\n  text-decoration: none;\n}\n.product-categories li a:hover {\n  color: #2962ff;\n}\n\n.table thead {\n  background: #f3f6f9;\n}\n.table .bg-none {\n  background: none;\n}\n.table .border-none th {\n  border-top: none;\n  padding-top: 0;\n}\n.table th {\n  font-size: 13px;\n}\n.table th, .table td {\n  border-bottom: 1px solid #eee;\n}\n.table td {\n  color: #797979;\n}\n.table .badge {\n  font-weight: 500;\n  padding: 5px 7px;\n}\n.table a {\n  color: #797979;\n  text-decoration: none;\n}\n.table a:hover {\n  color: #2962ff;\n}\n.table tr.active {\n  background: #f3f6f9;\n}\n\n.table > :not(caption) > * > * {\n  padding: 11px 0.5rem;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #fff;\n}\n.table-striped tbody tr:nth-of-type(even) {\n  background-color: #f3f6f9;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f3f6f9;\n}\n\n.table-dark thead {\n  background: #212529;\n}\n.table-dark td {\n  color: #fff;\n}\n\n/* End dashboard landing page v.1 style */\n/* Search result style */\n.search-result .single-product {\n  border: 1px solid #ebebee;\n  padding-left: 100px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-right: 45px;\n  margin-top: 20px;\n  border-radius: 6px;\n}\n.search-result .single-product img {\n  left: 20px;\n  top: 18px;\n}\n.search-result .single-product .view-link {\n  top: 35px;\n  right: 20px;\n}\n\n.page-link {\n  color: #2962ff;\n}\n.page-link:hover {\n  color: #000;\n}\n\n.page-item.active .page-link {\n  background-color: #2962ff;\n  border-color: #2962ff;\n}\n\n/* End search result style */\n/* Notifications page style */\n.notifications-card .noti-card-title {\n  background: #fff;\n  margin: 0;\n  padding: 15px 20px;\n  border-top: 1px solid #ebebee;\n  border-left: 1px solid #ebebee;\n  border-right: 1px solid #ebebee;\n  font-size: 15px;\n}\n.notifications-card .list-group .list-group-item {\n  border: 1px solid #ebebee;\n  padding: 15px 15px 15px 40px;\n  position: relative;\n  font-size: 13px;\n}\n.notifications-card .list-group .list-group-item:first-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.notifications-card .list-group .list-group-item a {\n  font-weight: 500;\n  color: #2962ff;\n  text-decoration: none;\n}\n.notifications-card .list-group .list-group-item a:hover {\n  text-decoration: underline;\n}\n.notifications-card .list-group .list-group-item .icon {\n  position: absolute;\n  left: 15px;\n  top: 16px;\n  width: 16px;\n  height: 16px;\n}\n.notifications-card .list-group .list-group-item span {\n  position: absolute;\n  left: 15px;\n  top: 15px;\n  font-size: 18px;\n}\n.notifications-card .list-group .list-group-item .time {\n  position: absolute;\n  right: 15px;\n  top: 17px;\n  color: #a1aab2;\n  font-size: 13px;\n}\n.notifications-card .list-group .list-group-item ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.notifications-card .list-group .list-group-item ul li {\n  display: inline-block;\n  margin-right: 5px;\n  margin-top: 5px;\n}\n.notifications-card .list-group .list-group-item .content {\n  padding-top: 10px;\n}\n.notifications-card .list-group .list-group-item .media {\n  padding: 15px;\n  border: 1px solid #ebebee;\n  border-radius: 5px;\n}\n\n.status {\n  position: absolute;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n}\n\n.online {\n  background: #42b72a;\n}\n\n.ofline {\n  background: #f62d51;\n}\n\n.away {\n  background: #ffbc34;\n}\n\n/* End Notifications page style */\n.notification-card-one a {\n  text-decoration: none;\n}\n\n/* Todo list style */\n.todo-list ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.todo-list ul li {\n  position: relative;\n  border: 1px solid #ebebee;\n  padding: 15px 40px 15px 45px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n.todo-list ul li .task {\n  font-size: 14px;\n}\n.todo-list ul li .completed {\n  text-decoration: line-through;\n  color: cadetblue;\n}\n.todo-list ul .close-btn {\n  background-color: transparent;\n  color: #f75d81;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  padding: 0;\n  height: 22px;\n  width: 22px;\n  font-size: 9px;\n  border-radius: 50%;\n  line-height: 22px;\n}\n.todo-list .add-new-task {\n  position: relative;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.todo-list .add-new-task .form-control {\n  border-color: #ebebee;\n  border-radius: 0;\n  background: #eef5f9;\n  height: 42px;\n  box-shadow: none;\n}\n.todo-list .add-new-task .btn-primary {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-radius: 0;\n  height: 42px;\n}\n\n.control {\n  display: block;\n  position: absolute;\n  cursor: pointer;\n  left: 15px;\n  top: 12px;\n}\n.control input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.control .control-indicator {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  height: 22px;\n  width: 22px;\n  border: 1px solid #e6e6e6;\n  border-radius: 50%;\n}\n\n.control input:checked ~ .control-indicator {\n  background: #2962ff;\n}\n\n.control-indicator:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.control input:checked ~ .control-indicator:after {\n  display: block;\n}\n\n.control-checkbox .control-indicator:after {\n  left: 7px;\n  top: 3px;\n  width: 6px;\n  height: 11px;\n  border: 1px solid #e6e6e6;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* End Todo list style */\n/* Signup page style */\n.auth-main-content {\n  height: 100vh;\n  padding: 0 15px;\n}\n\n.auth-box {\n  max-width: 750px;\n  margin: 30px auto;\n  background: #fff;\n  border-radius: 10px;\n  position: relative;\n  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.auth-box::before {\n  content: \"\";\n  position: absolute;\n  background: #ebebee;\n  height: 100%;\n  width: 1px;\n  left: 0;\n  right: 0;\n  margin: auto;\n  top: 0;\n}\n\n.form-left-content {\n  padding: 50px 30px 50px 30px;\n}\n.form-left-content .auth-logo {\n  text-align: center;\n  font-size: 25px;\n  color: #2962ff;\n  line-height: 1;\n}\n.form-left-content .login-links a {\n  display: block;\n  margin-top: 15px;\n  line-height: 1;\n  padding: 8px 15px;\n  border-radius: 30px;\n  text-align: center;\n  text-decoration: none;\n}\n.form-left-content .login-links a .icon {\n  width: 15px;\n  height: 15px;\n  margin-right: 5px;\n  margin-top: -2px;\n}\n.form-left-content .login-links a span {\n  padding-right: 5px;\n}\n.form-left-content .login-links .fb {\n  background: #3B5998;\n  color: #fff;\n  border: 1px solid #3B5998;\n}\n.form-left-content .login-links .fb:hover {\n  border-radius: 0;\n}\n.form-left-content .login-links .twi {\n  border: 1px solid #3CF;\n  background: #3CF;\n  color: #fff;\n}\n.form-left-content .login-links .twi:hover {\n  border-radius: 0;\n}\n.form-left-content .login-links .ema {\n  border: 1px solid #DC4A38;\n  background: #DC4A38;\n  color: #fff;\n}\n.form-left-content .login-links .ema:hover {\n  border-radius: 0;\n}\n.form-left-content .login-links .linkd {\n  border: 1px solid #007bb6;\n  background: #007bb6;\n  color: #fff;\n}\n.form-left-content .login-links .linkd:hover {\n  border-radius: 0;\n}\n\n.form-content {\n  padding: 50px 30px 50px 30px;\n}\n.form-content .heading {\n  margin: 0 0 20px;\n  position: relative;\n  font-size: 18px;\n  border-bottom: 1px solid #ebebee;\n  padding-bottom: 8px;\n  font-weight: 600;\n}\n.form-content .heading::before {\n  content: \"\";\n  background: #2962ff;\n  height: 1px;\n  width: 30px;\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n}\n.form-content .form-control {\n  height: 35px;\n  border-radius: 30px;\n  border: 1px solid #ebebeb;\n}\n.form-content .btn-primary {\n  border-radius: 30px;\n  font-size: 13px;\n  padding: 10px 20px;\n  line-height: 1;\n  width: 100%;\n}\n.form-content .fp-link {\n  display: block;\n  margin-top: 15px;\n  max-width: 120px;\n  margin-left: auto;\n  margin-right: auto;\n  color: #47404f;\n}\n.form-content .fp-link:hover {\n  color: #2962ff;\n  text-decoration: underline;\n}\n\n.auth-bg-image {\n  background-image: url(\"../img/trailer_wearhouse.png\");\n  background-position: center center;\n  background-attachment: fixed;\n  background-size: cover;\n}\n\n/* End signup page style */\n/* Notes page style */\n.notes-card {\n  position: relative;\n}\n.notes-card button {\n  background: #f75d81;\n  border-color: #f75d81;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 5px;\n  font-size: 10px;\n  border-radius: 0;\n}\n\n.notes-content .form-control {\n  border-radius: 0;\n  border-color: #ebebee;\n  box-shadow: none;\n  padding: 15px;\n  line-height: 26px;\n}\n.notes-content form {\n  position: relative;\n}\n.notes-content form .btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* End notes page style */\n/* Map style */\n.map-content {\n  width: 100%;\n  height: 500px;\n}\n\n/* End map style */\n/* Calendar style */\n.react-calendar {\n  width: 100%;\n  margin-top: 20px;\n  border: 1px solid #e3e3e3;\n}\n.react-calendar button span {\n  font-weight: 600;\n  font-size: 15px;\n}\n.react-calendar .react-calendar__month-view__weekdays {\n  font-size: 13px;\n}\n.react-calendar .react-calendar__tile {\n  font-size: 14px;\n  border: 1px solid #eee !important;\n  padding: 30px 8px;\n}\n\n/* End Calendar style */\n/* List group */\n.card-header + .list-group .list-group-item:first-child {\n  border-top: 1px solid #ebebeb;\n  border-radius: 0;\n}\n\n.list-group-item:last-child {\n  border-radius: 0;\n}\n\n/* End List group */\n/* Modal style */\n.modal-dialog .modal-content {\n  border-radius: 0;\n}\n.modal-dialog .modal-content .modal-header {\n  padding: 20px 30px;\n}\n.modal-dialog .modal-content .modal-header .modal-title {\n  font-size: 22px;\n  line-height: 1;\n}\n.modal-dialog .modal-content .modal-body {\n  padding: 30px;\n}\n.modal-dialog .modal-content .modal-footer {\n  padding: 20px 30px;\n}\n.modal-dialog p {\n  line-height: 25px;\n}\n\n.modal-90w {\n  width: 90%;\n  max-width: none !important;\n}\n\n/* End Modal style */\n/* Tab style */\n.tab-content p {\n  margin-bottom: 10px;\n}\n.tab-content p:last-child {\n  margin: 0;\n}\n\n.tabs-style-one .tab-content {\n  padding: 20px;\n  border-bottom: 1px solid #ebebee;\n  border-left: 1px solid #ebebee;\n  border-right: 1px solid #ebebee;\n}\n.tabs-style-one .nav-tabs .nav-link {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  color: #495057;\n}\n\n.tabs-style-two .tab-content {\n  padding: 20px;\n  border-bottom: 1px solid #ebebee;\n  border-left: 1px solid #ebebee;\n  border-right: 1px solid #ebebee;\n}\n.tabs-style-two .nav-tabs .nav-link {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  color: #495057;\n}\n.tabs-style-two .nav-tabs .nav-link.active, .tabs-style-two .nav-tabs .nav-item.show .nav-link {\n  color: #fff;\n  background-color: #2962ff;\n  border-color: #2962ff;\n}\n\n.tabs-style-three .tab-content {\n  padding: 20px;\n  border-bottom: 1px solid #ebebee;\n  border-left: 1px solid #ebebee;\n  border-right: 1px solid #ebebee;\n}\n.tabs-style-three .nav-tabs .nav-link {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  color: #495057;\n  border-top: 2px solid transparent;\n}\n.tabs-style-three .nav-tabs .nav-link:hover {\n  border-top: 2px solid #2962ff;\n  border-bottom-color: #fff;\n}\n.tabs-style-three .nav-tabs .nav-link.active, .tabs-style-three .nav-tabs .nav-item.show .nav-link {\n  border-top: 2px solid #2962ff;\n}\n\n.pill-tab .nav {\n  border-bottom: 1px solid #ebebee;\n}\n.pill-tab .nav-pills .nav-link {\n  border-radius: 0;\n  color: #495057;\n}\n.pill-tab .nav-pills .nav-link:hover {\n  color: #2962ff;\n}\n.pill-tab .nav-pills .nav-link.active, .pill-tab .nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #797979;\n}\n.pill-tab .tab-content {\n  margin-top: 20px;\n}\n\n.vertical-pills-tab .nav-pills .nav-link {\n  border-radius: 0;\n  color: #495057;\n}\n.vertical-pills-tab .nav-pills .nav-link:hover {\n  color: #2962ff;\n}\n.vertical-pills-tab .nav-pills .nav-link.active, .vertical-pills-tab .nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #2962ff;\n}\n\n/* End Tab style */\n/* Inbox style */\n.inbox-main-sidebar .nav-pills {\n  margin-top: 20px;\n}\n.inbox-main-sidebar .nav-pills .nav-link {\n  border-radius: 0px;\n  color: #47404f;\n}\n.inbox-main-sidebar .nav-pills .nav-link:hover {\n  color: #2962ff;\n  background-color: #fff;\n}\n.inbox-main-sidebar .nav-pills .nav-link.active {\n  color: #2962ff;\n  background-color: #fff;\n}\n\n.inbox-content-wrap {\n  background: #fff;\n}\n\ntextarea.form-control {\n  line-height: 22px;\n}\n\n.mail-item-nav {\n  border-right: 1px solid #eee;\n  height: 720px;\n  overflow-y: auto;\n}\n.mail-item-nav .nav-pills .nav-link {\n  border-radius: 0;\n  border-bottom: 1px solid #eee;\n  padding: 20px 15px;\n  position: relative;\n  overflow: hidden;\n}\n.mail-item-nav .nav-pills .nav-link:hover {\n  background-color: #fafafa;\n}\n.mail-item-nav .nav-pills .nav-link:hover::before {\n  content: \"\";\n  position: absolute;\n  right: -18px;\n  background: #2962ff;\n  height: 15px;\n  width: 40px;\n  transform: rotate(-45deg);\n  bottom: 0;\n}\n.mail-item-nav .nav-pills .nav-link img {\n  position: absolute;\n}\n.mail-item-nav .nav-pills .nav-link .info {\n  padding-left: 40px;\n}\n.mail-item-nav .nav-pills .nav-link .info .name {\n  line-height: 1;\n  color: #70657b;\n  font-size: 13px;\n  font-weight: 500;\n}\n.mail-item-nav .nav-pills .nav-link .info p {\n  color: #47404f;\n  margin: 6px 0 0;\n  line-height: 1;\n  font-size: 12px;\n}\n.mail-item-nav .nav-pills .nav-link .info .date {\n  right: 15px;\n  position: absolute;\n  top: 20px;\n  color: #797979;\n  font-size: 11px;\n  line-height: 1;\n}\n.mail-item-nav .nav-pills .nav-link.active {\n  background-color: #fafafa;\n}\n.mail-item-nav .nav-pills .nav-link.active::before {\n  content: \"\";\n  position: absolute;\n  right: -18px;\n  background: #2962ff;\n  height: 15px;\n  width: 40px;\n  transform: rotate(-45deg);\n  bottom: 0;\n}\n\n.email-details-warp {\n  height: 720px;\n  overflow-y: auto;\n  padding: 30px 30px 30px 0;\n  position: relative;\n}\n.email-details-warp p {\n  color: #797979;\n  font-size: 13px;\n}\n.email-details-warp .inbox-topbar {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n}\n.email-details-warp .inbox-topbar .btn {\n  border-radius: 30px;\n  padding: 5px 10px;\n  font-size: 10px;\n}\n\n/* End Inbox style */\n/* Marketing content */\n.marketing-content .list {\n  position: relative;\n  padding-left: 50px;\n  margin-bottom: 11px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 11px;\n}\n.marketing-content .list:last-child {\n  margin-bottom: 0;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n.marketing-content .list > .icon {\n  width: 35px;\n  height: 35px;\n  color: #fff;\n  padding: 8px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 2px;\n}\n.marketing-content .list .fb {\n  background: #4267b2;\n}\n.marketing-content .list .ins {\n  background: #A1755C;\n}\n.marketing-content .list .twi {\n  background: #1da1f2;\n}\n.marketing-content .list .lin {\n  background: #0077B5;\n}\n.marketing-content .list .ytb {\n  background: #ff0000;\n}\n.marketing-content .list h3 {\n  margin: 0;\n  font-size: 13px;\n}\n.marketing-content .list h3 a {\n  color: #47404f;\n  text-decoration: none;\n}\n.marketing-content .list h3 a:hover {\n  color: #2962ff;\n}\n.marketing-content .list p {\n  margin: 7px 0 0;\n  line-height: 1;\n  font-size: 12px;\n}\n.marketing-content .list .stats {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.marketing-content .list .stats .icon {\n  width: 14px;\n  height: 14px;\n  margin-right: 8px;\n}\n\n/* End Marketing content */\n/* New customer card */\n.new-customer {\n  position: relative;\n  padding-left: 52px;\n  padding-top: 5px;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n.new-customer:last-child {\n  margin-bottom: 0;\n}\n.new-customer a {\n  text-decoration: none;\n}\n.new-customer .profile {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.new-customer .profile img {\n  width: 40px;\n  height: 40px;\n}\n.new-customer .price {\n  position: absolute;\n  right: 0;\n  top: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* End new customer card */\n/* Search contact */\n.search-contact {\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n}\n.search-contact .form-control {\n  height: 41px;\n}\n\n.chat-header {\n  border-bottom: 1px solid #eee;\n  padding: 8px 0;\n  margin-right: 30px;\n}\n\n.chat-details-warp {\n  padding: 30px 30px 110px 0;\n}\n\n.chat-list-right {\n  position: relative;\n  padding-right: 60px;\n  margin-bottom: 20px;\n}\n.chat-list-right > img {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.chat-list-right .chat-details {\n  background: #fafafa;\n  position: relative;\n  padding: 20px 20px 10px;\n}\n.chat-list-right .chat-details::before {\n  position: absolute;\n  content: \"\";\n  top: 14px;\n  right: -5px;\n  background: 0 0;\n  border-style: solid;\n  border-width: 0 12px 12px 0;\n  border-color: transparent transparent #fafafa;\n  transform: rotate(-135deg);\n}\n.chat-list-right .chat-details .name {\n  font-size: 15px;\n}\n.chat-list-right .chat-details .date {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: #797979;\n  font-size: 12px;\n}\n\n.chat-list-left {\n  position: relative;\n  padding-left: 60px;\n  margin-bottom: 20px;\n}\n.chat-list-left > img {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.chat-list-left .chat-details {\n  background: #fafafa;\n  position: relative;\n  padding: 20px 20px 10px;\n}\n.chat-list-left .chat-details::before {\n  position: absolute;\n  content: \"\";\n  top: 14px;\n  left: -5px;\n  background: 0 0;\n  border-style: solid;\n  border-width: 0 12px 12px 0;\n  border-color: transparent transparent #fafafa;\n  transform: rotate(45deg);\n}\n.chat-list-left .chat-details .name {\n  font-size: 15px;\n}\n.chat-list-left .chat-details .date {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: #797979;\n  font-size: 12px;\n}\n\n.chat-box {\n  background: #fff;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding-right: 30px;\n  padding-bottom: 30px;\n}\n\n/* End Search contact */\n/* Order stats card */\n.order-stats-card {\n  position: relative;\n}\n.order-stats-card h3 {\n  margin: 0;\n  font-size: 13px;\n}\n\n.order-number-stats {\n  text-align: center;\n}\n.order-number-stats .number {\n  font-weight: 500;\n  font-size: 18px;\n}\n.order-number-stats p {\n  margin: 0;\n  line-height: 1;\n}\n\n/* End order stats card */\n/* Visitor stats card */\n.visitor-stats {\n  background-color: #fff;\n  padding: 20px;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n  text-align: center;\n}\n.visitor-stats h3 {\n  margin: 0;\n  font-size: 22px;\n}\n.visitor-stats p {\n  margin: 5px 0 10px;\n  line-height: 1;\n}\n.visitor-stats p .icon {\n  width: 15px;\n  height: 15px;\n  margin: 0 5px;\n}\n\n/* End visitor stats card */\n/* Profile page style */\n.profile-header {\n  background-color: #fff;\n  padding: 30px;\n  text-align: center;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n  border-radius: 4px;\n}\n.profile-header .name {\n  margin: 0;\n  font-size: 18px;\n}\n.profile-header p {\n  margin: 5px auto 0;\n  max-width: 690px;\n  line-height: 22px;\n}\n.profile-header .profile-stats a {\n  display: inline-block;\n  margin-top: 10px;\n  margin-left: 8px;\n  margin-right: 8px;\n  color: #797979;\n  text-decoration: none;\n}\n.profile-header .profile-stats a strong {\n  color: #000;\n}\n.profile-header .profile-stats a:hover strong {\n  color: #2962ff;\n}\n\n.profile-left-content .info {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.profile-left-content .info li {\n  line-height: 22px;\n  position: relative;\n  color: #797979;\n  padding-left: 20px;\n  margin-bottom: 10px;\n}\n.profile-left-content .info li:last-child {\n  margin-bottom: 0;\n}\n.profile-left-content .info li .icon {\n  width: 14px;\n  height: 14px;\n  color: #000;\n  position: absolute;\n  left: 0;\n  top: 3px;\n}\n\n.profile-middle-content {\n  background-color: #fff;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n  border-radius: 4px;\n}\n\n.post-card {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n.post-card .content h5 {\n  font-size: 15px;\n  margin-bottom: 5px;\n  line-height: 22px;\n}\n.post-card .content h5 a {\n  color: #47404f;\n  text-decoration: none;\n}\n.post-card .content h5 a:hover {\n  color: #2962ff;\n}\n.post-card .content p {\n  margin: 0 0 10px;\n}\n.post-card .feed-back a {\n  color: #797979;\n  margin-right: 15px;\n  border-right: 1px solid #eee;\n  padding-right: 10px;\n  text-decoration: none;\n}\n.post-card .feed-back a:hover {\n  color: #2962ff;\n}\n.post-card .feed-back a:last-child {\n  border-right: none;\n  padding-right: 0;\n}\n.post-card .feed-back a .icon {\n  width: 17px;\n  height: 17px;\n  margin-right: 5px;\n  margin-top: -2px;\n}\n\n.profile-right-content .connecting-list {\n  height: 255px;\n  overflow-x: hidden;\n}\n.profile-right-content .list-content {\n  border-bottom: 1px solid #eee;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n}\n.profile-right-content .list-content:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.profile-right-content .list-content h5 {\n  margin: 0 0 8px;\n  font-size: 12px;\n}\n.profile-right-content .list-content h5 a {\n  color: #47404f;\n  text-decoration: none;\n}\n.profile-right-content .list-content h5 a:hover {\n  color: #2962ff;\n}\n.profile-right-content .list-content .btn {\n  font-size: 10px;\n  padding: 5px 12px;\n}\n\n/* Profile page style */\n.profile-settings-form {\n  padding: 30px;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n  max-width: 800px;\n  margin: auto;\n}\n\n/* Users card */\n.single-user-card {\n  background-color: #fff;\n  text-align: center;\n  border-radius: 4px;\n  box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1);\n}\n.single-user-card img {\n  background-color: #e0e0e0;\n  height: 120px;\n  width: 120px;\n}\n.single-user-card h4 {\n  font-size: 18px;\n}\n.single-user-card .social-links a {\n  display: inline-block;\n  margin: 0 5px;\n  color: #797979;\n}\n.single-user-card .social-links a:hover {\n  color: #2962ff;\n}\n.single-user-card .social-links a .icon {\n  width: 15px;\n  height: 15px;\n}\n.single-user-card .user-card-foot {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #eee;\n}\n.single-user-card .user-card-foot li {\n  display: inline-block;\n  display: inline-block;\n  width: 33.33%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  color: #797979;\n}\n.single-user-card .user-card-foot li span {\n  display: block;\n  font-weight: 500;\n  font-size: 18px;\n  color: #47404f;\n}\n.single-user-card .user-card-foot .bor-lr {\n  border-left: 1px solid #eee;\n  border-right: 1px solid #eee;\n}\n\n.octagon-style {\n  -webkit-clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n  clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n}\n\n.nonagon-style {\n  -webkit-clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);\n  clip-path: polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);\n}\n\n.bevel-style {\n  -webkit-clip-path: polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);\n  clip-path: polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);\n}\n\n/* End Users card */\n/* TimeLine Style */\n.timeline-centered {\n  position: relative;\n  margin-bottom: 30px;\n}\n.timeline-centered:before, .timeline-centered:after {\n  content: \"\";\n  display: table;\n}\n.timeline-centered:after {\n  clear: both;\n}\n.timeline-centered:before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 4px;\n  background: #fff;\n  left: 50%;\n  top: 20px;\n  bottom: 20px;\n  margin-left: -4px;\n}\n.timeline-centered .timeline-card {\n  position: relative;\n  width: 50%;\n  float: right;\n  margin-bottom: 40px;\n  clear: both;\n}\n.timeline-centered .timeline-card:before, .timeline-centered .timeline-card:after {\n  content: \" \";\n  display: table;\n}\n.timeline-centered .timeline-card:after {\n  clear: both;\n}\n.timeline-centered .timeline-card:before, .timeline-centered .timeline-card:after {\n  content: \" \";\n  display: table;\n}\n.timeline-centered .timeline-card:after {\n  clear: both;\n}\n.timeline-centered .timeline-card.begin {\n  margin-bottom: 0;\n}\n.timeline-centered .timeline-card.left-aligned {\n  float: left;\n}\n.timeline-centered .timeline-card.left-aligned .timeline-body {\n  margin-left: 0;\n  margin-right: -18px;\n}\n.timeline-centered .timeline-card.left-aligned .timeline-body .time {\n  left: auto;\n  right: -100px;\n  text-align: left;\n}\n.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-icon {\n  float: right;\n}\n.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-label {\n  margin-left: 0;\n  margin-right: 70px;\n}\n.timeline-centered .timeline-card.left-aligned .timeline-body .timeline-label:after {\n  left: auto;\n  right: 0;\n  margin-left: 0;\n  margin-right: -9px;\n  transform: rotate(180deg);\n}\n.timeline-centered .timeline-card .timeline-body {\n  position: relative;\n  margin-left: -22px;\n}\n.timeline-centered .timeline-card .timeline-body:before, .timeline-centered .timeline-card .timeline-body:after {\n  content: \" \";\n  display: table;\n}\n.timeline-centered .timeline-card .timeline-body:after {\n  clear: both;\n}\n.timeline-centered .timeline-card .timeline-body:before, .timeline-centered .timeline-card .timeline-body:after {\n  content: \" \";\n  display: table;\n}\n.timeline-centered .timeline-card .timeline-body:after {\n  clear: both;\n}\n.timeline-centered .timeline-card .timeline-body .time {\n  position: absolute;\n  left: -100px;\n  text-align: right;\n}\n.timeline-centered .timeline-card .timeline-body .time > span {\n  display: block;\n}\n.timeline-centered .timeline-card .timeline-body .time > span:first-child {\n  font-size: 15px;\n  font-weight: 500;\n}\n.timeline-centered .timeline-card .timeline-body .time > span:last-child {\n  font-size: 12px;\n  color: #797979;\n}\n.timeline-centered .timeline-card .timeline-body .timeline-icon {\n  background: #fff;\n  color: #737881;\n  display: block;\n  width: 40px;\n  height: 40px;\n  border-radius: 30px;\n  text-align: center;\n  box-shadow: 0 0 0 4px #fff;\n  line-height: 40px;\n  font-size: 15px;\n  float: left;\n}\n.timeline-centered .timeline-card .timeline-body .timeline-label {\n  position: relative;\n  background: #fff;\n  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);\n  padding: 1.7em;\n  margin-left: 70px;\n  border-radius: 4px;\n}\n.timeline-centered .timeline-card .timeline-body .timeline-label:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 10px 10px 10px 0;\n  border-color: transparent #fff transparent transparent;\n  left: 0;\n  top: 10px;\n  margin-left: -9px;\n}\n.timeline-centered .timeline-card .timeline-body .timeline-label h3 {\n  font-size: 18px;\n  margin-bottom: 5px;\n  line-height: 25px;\n}\n.timeline-centered .timeline-card .timeline-body .timeline-label p {\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.timeline-icon.bg-purple {\n  background-color: #7266ba !important;\n  color: #fff;\n}\n.timeline-icon.bg-purple .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-primary {\n  background-color: #2962ff;\n  color: #fff;\n}\n.timeline-icon.bg-primary .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-secondary {\n  background-color: #ee4749;\n  color: #fff;\n}\n.timeline-icon.bg-secondary .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-success {\n  background-color: #7ed320;\n  color: #fff;\n}\n.timeline-icon.bg-success .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-info {\n  background-color: #21a9e1;\n  color: #fff;\n}\n.timeline-icon.bg-info .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-warning {\n  background-color: #fad839;\n  color: #fff;\n}\n.timeline-icon.bg-warning .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n.timeline-icon.bg-danger {\n  background-color: #f75d81;\n  color: #fff;\n}\n.timeline-icon.bg-danger .icon {\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  margin-top: -2px;\n}\n\n/* End TimeLine Style */\n/* Invoice Template */\n.invoice-template {\n  background: #fff;\n  padding: 20px;\n}\n.invoice-template .invoice-header {\n  position: relative;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 15px;\n}\n.invoice-template .invoice-header h3 {\n  margin: 0;\n  font-size: 20px;\n  text-transform: uppercase;\n}\n.invoice-template .invoice-header p {\n  color: #47404f;\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-weight: 500;\n  font-size: 18px;\n}\n\n/* End Invoice Template */\n/* Error page design */\n.error-content {\n  padding: 30px;\n  text-align: center;\n  height: 100vh;\n}\n.error-content .icon {\n  width: 50px;\n  height: 50px;\n  color: #797979;\n}\n.error-content h1 {\n  font-size: 100px;\n  font-weight: bolder;\n}\n.error-content h3 {\n  margin: 0;\n}\n.error-content p {\n  margin: auto;\n  max-width: 500px;\n}\n.error-content .back-link {\n  background-color: #2962ff;\n  color: #fff;\n  display: inline-block;\n  border: 1px solid #2962ff;\n  padding: 10px 30px;\n  border-radius: 100px;\n  margin-top: 30px;\n  text-decoration: none;\n}\n.error-content .back-link:hover {\n  background-color: #333;\n  border-color: #333;\n}\n\n/* End error page design */\n/* Map Style */\n.map-height-500 {\n  height: 500px;\n}\n\n.jvectormap-container {\n  padding: 20px;\n}\n\n/* End Map Style */\n/* Apexcharts content */\n.apexcharts-content {\n  width: 100%;\n}\n.apexcharts-content .toolbar {\n  margin-left: 45px;\n}\n.apexcharts-content .toolbar button {\n  background: #fff;\n  color: #222;\n  border: 1px solid #e7e7e7;\n  border-bottom: 2px solid #ddd;\n  border-radius: 2px;\n  padding: 4px 17px;\n  cursor: pointer;\n}\n.apexcharts-content .toolbar button.active {\n  color: #fff;\n  background: #2962ff;\n  border: 1px solid #2962ff;\n  border-bottom: 2px solid #2962ff;\n}\n\n/* End Apexcharts content */\n/* Accordion style  */\n.custom-accordion .heading {\n  margin-bottom: 20px;\n  font-size: 20px;\n}\n.custom-accordion .accordion__item + .accordion__item {\n  border-top: 1px solid #eee;\n}\n.custom-accordion .accordion__button {\n  position: relative;\n  background-color: #fff;\n  padding: 20px;\n  font-weight: 500;\n  font-size: 17px;\n}\n.custom-accordion .accordion__button:focus {\n  outline: 0;\n}\n.custom-accordion .accordion__button:hover {\n  color: #2962ff;\n}\n.custom-accordion .accordion__button:before {\n  float: right;\n  margin-top: 7px;\n}\n.custom-accordion .accordion__panel {\n  background-color: #fff;\n  border-top: 1px solid #eee;\n}\n.custom-accordion .accordion__panel p {\n  margin-bottom: 10px;\n}\n.custom-accordion .accordion__panel p:last-child {\n  margin-bottom: 0;\n}\n\n/* End accordion style  */\n/* Icon preview style */\n.icon-preview {\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 20px;\n  position: relative;\n}\n.icon-preview span {\n  padding-left: 10px;\n  font-size: 15px;\n  color: #777;\n  position: absolute;\n  margin-top: 2px;\n}\n\n/* End Icon preview style */\n/* Switch Button */\n.side-menu-switch {\n  position: absolute;\n  top: 92px;\n  right: 30px;\n  z-index: 5;\n}\n.side-menu-switch .switch {\n  position: relative;\n  display: inline-block;\n  width: 45px;\n  height: 26px;\n}\n.side-menu-switch .switch input {\n  display: none;\n}\n.side-menu-switch .switch .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #2c2f48;\n  transition: 0.4s;\n}\n.side-menu-switch .switch .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  background-color: white;\n  top: 3px;\n  transition: 0.4s;\n  -webkit-transition: 0.4s;\n}\n.side-menu-switch .switch input.light:checked + .slider {\n  background-color: #fff;\n}\n.side-menu-switch .switch input.light:checked + .slider:before {\n  background-color: #2962ff;\n}\n.side-menu-switch .switch input:checked + .slider:before {\n  transform: translateX(18px);\n}\n.side-menu-switch .switch .slider.round {\n  border-radius: 30px;\n  box-shadow: 0 0 8px #ddd;\n}\n.side-menu-switch .switch .slider.round:before {\n  border-radius: 50%;\n}\n\n/* End Switch Button */\n/* Pricing Table style */\n.pricing-table {\n  background: #fff;\n  border-radius: 4px;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease 0s;\n}\n.pricing-table svg {\n  display: block;\n  margin-left: -1px;\n}\n.pricing-table .price {\n  position: absolute;\n  top: 0;\n  color: #fff;\n  font-size: 55px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n  margin: 0;\n  top: 50%;\n  transform: translateY(-70%);\n  -webkit-transform: translateY(-70%);\n}\n.pricing-table .price span {\n  display: block;\n  font-size: 15px;\n  font-weight: 300;\n  padding-left: 60px;\n}\n.pricing-table .pricing-content {\n  padding: 40px 0 30px;\n  position: relative;\n}\n.pricing-table .title {\n  font-size: 25px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin: 0 0 10px 0;\n}\n.pricing-table .pricing-content ul {\n  padding: 0;\n  margin: 20px 0;\n  list-style-type: none;\n}\n.pricing-table .pricing-content ul li {\n  font-size: 15px;\n  line-height: 40px;\n  border-top: 1px solid #eee;\n  color: #656565;\n}\n.pricing-table .signup {\n  display: inline-block;\n  padding: 8px 50px;\n  border-radius: 20px;\n  font-size: 18px;\n  color: #fff;\n  text-transform: uppercase;\n  position: relative;\n  transition: all 0.3s ease 0s;\n}\n\n/* End Pricing Table style */\n/* Footer Style */\n.footer {\n  background: #fff;\n  padding: 15px 30px;\n  text-align: center;\n  -webkit-clip-path: polygon(1% 0, 99% 0, 100% 100%, 0% 100%);\n  clip-path: polygon(1% 0, 99% 0, 100% 100%, 0% 100%);\n  border-radius: 30px 30px 0 0;\n}\n.footer p {\n  margin: 0;\n  color: #5a5151;\n}\n.footer p a {\n  color: #2962ff;\n}\n.footer p a:hover {\n  text-decoration: underline;\n}\n\n/* End Footer Style *//*# sourceMappingURL=style.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
